import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const storedLanguage = localStorage.getItem("preferredLanguage");

const resources = {
  en: {
    translation: {
      label: {},
      error: {},
      message: {},
      text: {
        AddNewPetrolPump: "Add New PetrolPump",
        cancel: "Cancel",
        EnterDesignationCode: "Enter Designation Code",
        EnterDesignation: "Enter Designation Name",
        EditEmployeeRegistration: "Edit Employee Registration",
        empStatus: "Select Status",
        EnterCode: "Enter Code",
        SelectZone: "Select Zone",
        DesignationCode1: "Designation Code",
        eScarp1: "Save Escrap Also",
        PetrolPumpName1: "PetrolPump Name",
        SelectStatus: "Select Status",
        Emaileventname1: "Email Event Name",
        Emaileventtype1: "Email Event Type",

        //employee

        Emailcampaigname1: "Email Campaign Name",
        Status1: "Status",
        Emailcampaign: "Create Email Campaign",
        toTime: "To Time",
        listGroups: "Select Group",
        listMembers: "Select Member",
        Emailcampaign1: "Email Campaign",
        EditEmailcampaign: "Edit Email Campaign",
        EnterEmployeeName: "Enter Employee Name",
        EnterEmployeeCode: "Enter Employee Code",
        EnterAdharNumber: "Enter Aadhar Number",
        SelectCity: "Select District",
        EnterPermanentAddress: "Enter Permanent Address",
        EnterPincode: "Enter Pincode",
        AttachedSignature: "Attached Signature",
        CreateEmployeeRegistration: "Create Employee Registration",
        EnterDrivingLicense: "Enter Driving License No.",
        SaveEscrapAlso: "Save Escrap Also",
        Designation1: "Select Designation",

        AddDesignation: "Create Designation",
        email12: "Email",
        isActive12: "Currently Active",
        Emailsettingmaster: "Email Settings",
        Type: "Select Type",
        isActive: "Status",
        AddEmaileventsetting: "Create Email Event Setting",
        EditEmaileventsetting: "Edit Email Event Setting",
        EmailtoDate: "To Date",
        EMAIL: "EMAIL",
        SMS: "SMS",
        templateId: "Enter Template Id",
        DepartmentName1: "Enter Department Name",
        wiretemp: "Wire Temp",
        Empdeptmaster: "Department Master",
        Departmentshortname1: "Enter Department Shortname",
        Headofdpt1: "Select Head Of Department",
        Editempdept: "Edit Department",
        EMAILGroup: "EMAIL Group",
        SMSGroup: "SMS Group",
        //campaign template
        CampaignTemplate: "Campaign Template",
        smsTemplateID: "Enter SMS Template ID",
        smsTemplateID1: "SMS Template ID",
        template: "Template",
        templateType: "Template Type",
        EditCampaignTemplate: "Edit Campaign Template",
        AddCampaignTemplate: "Create Campaign Template",

        //aniket sahu
        EditQualityCheck: "Edit Quality Check",
        VehicleDetail: "Vehicle Detail",
        VehicleDetailAdd: "Create Vehicle Detail",
        VehicleDetailEdit: "Edit Vehicle Detail",
        EnterZone: "Select Zone",
        VehicleName: "Vehicle Name",
        Code: "Enter Code",
        HsnCode: "Enter HsnCode",
        Category: "Select Category",
        VehicleType: "Select Vehicle Type",
        EnterUnit: "Select Unit",
        Tax: "Select Tax",

        VehicleNe: "Enter Vehicle No",
        SimNo: "Enter Sim No",
        SimType: "Select Sim Type",
        SimCompanyName: "Enter Sim Company Name",
        SerialNo: "Enter Serial No",
        ChasisNo: "Enter Chasis No",
        PurchaseYear: "Purchase Year",
        UnderControlOF: "Select Under Control Of",
        Department: "Enter Department",
        Designation: "Enter Designation",
        VehicleType: "Select Vehicle Type",
        BrandType: "Select Brand Type",
        FuelType: "Select Fuel Type",
        Weight: "Enter Weight (KG)",
        LitrePerHour: "Enter Litre Per Hour",
        KMperLitre: "Enter KM per Litre",
        DeviceNo: "Enter Device No",
        DeviceType: "Select Device Type",
        RFID1: "Enter RFID1",
        RFID2: "Enter RFID2",
        AllotedFuel: "Enter Alloted Fuel",
        EnterZone: "Select Zone",
        EnterDepartment: "Select Department",

        //brand master
        BrandMaster: "Brand Master",
        BrandMasterAdd: "Create Brand Master",
        BrandMasterEdit: "Edit Brand Master ",
        BrandName: "Enter Brand Name",
        BrandCode: "Enter Brand Code",
        ShortName: "Enter Short Name",

        BrandNames: "Brand Name",
        BrandCodes: "Brand Code",
        BrandShortNames: "Short Name",

        //fuel Type
        FuelTypes: "Fuel Type",
        FuelTypeAdd: "Create Fuel Type",
        FuelTypeEdit: "Edit Fuel Type ",
        FuelTypeName: "Enter Fuel Type Name",
        FuelCode: "Enter Fuel Code",
        FuelShortName: "Enter Fuel ShortName",
        FuelTypeNames: "Fuel Type Name",
        FuelCodes: "Fuel Code",
        FuelShortNames: "Fuel ShortName",

        //Vehicletype
        VehicleTypes: "Vehicle Type",
        VehicleTypeAdd: "Create  Vehicle Type",
        VehicleTypeEdit: "Edit Vehicle Type",
        VehicleTypeName1: "Enter Vehicle Type Name",
        VehicleCode: "Enter Vehicle Code",
        VehicleShortName: "Enter Vehicle ShortName",
        VehicleTypeNames: "Vehicle Type Name",
        VehicleCodes: "Vehicle Code",
        VehicleShortNames: "Vehicle ShortName",

        //vehicletypeIfo
        VehicleTypeInfo: "Vehicle Type Info",
        VehicleTypeInfoAdd: "Create Vehicle Type Info",
        VehicleTypeInfoEdit: "Edit Vehicle Type Info",
        PetrolPumpName: "Enter PetrolPump Name",
        EffectiveDate: "Enter Effective Date",
        VehicleTypeName: "Vehicle Type",
        Shift1: "Enter Shift-1(Fuel(Lt))",
        Shift2: "Enter Shift-2(Fuel(Lt))",
        PetrolPump: "Select PetrolPump",
        FirstSessionFuelLts: "First Session Fuel(Lts)",
        SecondSessionFuelLts: "Second Session Fuel(Lts)",
        PetrolPumps: "PetrolPump",
        EffectiveDates: "Effective Date",

        //VehicleAudit
        NewInstallation: "New  Installation",
        Updation: "Updation",
        ReplacementInfo: "Replacement Info",
        Sim: "Sim",
        Device: "Device",
        Both: "Both",

        VehicleAudit: "Vehicle Audit",
        VehicleAuditAdd: "Create Vehicle Audit",
        VehicleAuditEdit: "Edit Vehicle Audit",
        VehicleNos1: "Select Vehicle No.",
        DriverName: "Enter Driver Name",
        DriverMobileNo: "Enter Driver Mobile No.",
        ServiceEngg: "Enter Service Engineer",
        SimNo: "Enter Sim No.",
        OldSimNo: "Enter Old Sim No.",
        DeviceNo: "Enter Device No.",
        OldDeviceNo: "Enter Old Device No.",
        ProblemType: "Select Problem Type",
        Remark1: "Enter Remark",
        Image: "Upload Image",
        VehicleNo12: "Vehicle No.",
        ServiceEng1: "Service Engineer",

        //FuelBalCorrection
        FuelBalCorrection: "Fuel Bal Correction",
        FuelBalCorrectionAdd: "Create Fuel Bal Correction",
        FuelBalCorrectionEdit: "Edit Fuel Bal Correction",
        VehicleNo: "Select Vehicle No",
        forallvehicle: "for All Vehicle",
        devid: "Device No.",
        trackDate: "Track Date",
        opBalanceExist: "OP Balance",
        opBalanceCorr: "Correct Balance",

        //group

        name: "Name",
        name1: "Enter Name",
        description1: "Enter Description",
        description: "Description",
        Creategroupmaster: "Create Group",
        Groupmaster: "Group",
        Editgroupmaster: "Edit Group",

        //email compaign
        Emailcampaign: "Create Email Campaign",
        toTime: "To Time",
        listGroups: "Select Group",
        listMembers: "Select Member",

        //area ward
        AreaName: "Area Name",
        WardNumber: "Ward Number",
        Zone: "Zone",
        AreaWard: "Ward/Area",
        AreaWardEdit: "Edit Area/Ward",
        EnterAreaName: "Enter Area Name",
        EnterWardNumber: "Enter Ward Number",
        EnterZone: "Enter Zone",

        //BinKudaghar
        BinKudaghar: "Bin/Kudaghar",
        BinSrNo: "Srno",
        BinName: "Bin Name",
        BinCode: "Bin Code",
        BinRFID: "RFID",
        BinArea: "Area",
        BinWard: "Ward",
        BinZone: "Zone",
        BinLatitude: "Latitude",
        BinLongitude: "Longitude",
        AddBin: "Add Bin",
        EnterBinAreaName: "Enter Area Name",
        EnterBinWardNumber: "Enter Ward Number",
        EnterBinZone: "Enter Zone",
        EnterBinName: "Enter Bin Name",
        EnterBinCode: "Enter Bin Code",
        EnterBinRFID: "Enter Bin RFID",
        EnterBinDesc: "Enter Bin Description",
        EditBinData: "Edit Bin Data",

        //HandheldInfo
        HandheldInfo: "Handheld Info",
        HandheldDeviceName: "Device Name",
        HandheldDeviceCode: "Device Code",
        EnterDeviceName: "Enter Device Name",
        EnterDeviceCode: "Enter Device Code",
        AddHandheldInfo: "Add Handheld Info",
        EditHandheldInfo: "Edit Handheld Info",

        //RouteDetail
        RouteDetail: "Route Detail",
        RouteName: "Route Name",
        RouteDesc: "Route Description",
        RouteDate: "Route Date",
        AddRouteDetail: "Add Route Detail",
        EditRouteDetail: "Edit Route Detail",
        EnterRouteName: "Enter Route Name",
        EnterRouteDesc: "Enter Route Description",
        EnterRouteDate: "Enter Route Date",

        //RosterPlan
        RosterPlan: "Roster Plan",
        RosterNumber: "Roster Number",
        RosterDate: "Roster Date",
        RosterFromDate: "From Date",
        RosterToDate: "To Date",
        AddRosterPlan: "Add Roster Plan",
        EditRosterPlan: "Edit Roster Plan",
        EnterRosterNumber: "Enter Roster Number",
        EnterRosterDate: "Enter Roster Date",
        EnterRosterFromDate: "Enter From Date",
        EnterRosterToDate: "Enter To Date",

        //BinKudagharPriority
        BinPriority: "Bin/Kudaghar Priority",
        BinPriorityRouteName: "Route Name",
        BinPriorityDesc: "Description",
        BinPriorityDate: "Route Date",
        EnterBinRouteName: "Enter Route Name",
        EnterBinRouteDate: "Enter Route Date",
        EnterBinDesc: "Enter Description",
        EnterBinTime: "Enter Time",
        EnterBinTimeInterval: "Enter Time Interval",
        AddBinPriority: "Add Bin/Kudaghar Priority",
        EditBinPriority: "Edit Bin/Kudaghar Priority",

        //himanshu
        groupadd: "Create Group",
        SelectEmployeeName: "Select Employee Name",
        ParentName: "Parent Name",
        EmployeeMaster: "Employee Master",
        EmpName: "Employee Name",
        EmpCode: "Employee Code",
        EmpStatus: "Employee Status",
        SelectState: "Select State",
        SelectCountry: "Select Country",
        SelectDistrict: "Select District",
        reqEmpName: "Employee name Is Require",
        reqEmpCode: "Employee Code is Require",
        reqFatherName: "Father Name Is Require",
        reqMobNo: "Mobile Number Is Require",
        reqPanNo: "Pan Number Is Require",
        reqJoiningDate: "Joining Date Is Require",
        reqDesignation: "Designation Is Require",
        reqDepartment: "Department Is Require",
        reqPerAddress: "Permanent Address Is Require",
        reqPinCode: "Pin Code Is Require",
        reqAdharNo: "Adhar Number Is Require",
        reqEmail: "Email Is Require",
        reqEmpdob: "Employee DOB Is Required",
        CreateEmployeeReg: "Create Employee Registration",
        EditEmployeeReg: "Edit Employee Registration",
        EnterEmpName: "Enter Employee Name",
        EnterEmpCode: "Enter Employee Code",
        EnterFatherName: "Enter Father Name",
        EnterSpauseName: "Enter Spouse Name",
        EnterMotherName: "Enter Mother Name",
        EnterMobileNumber: "Enter Mobile Number",
        EnterEmail: "Enter Email",
        EnterPanNo: "Enter Pan Number",
        EnterAdharNo: "Enter Adhar Number",
        EnterDOB: "Enter Date Of Birth",
        EnterJoiningDate: "Enter Joining Date",
        EnterRetirementDate: "Enter Retirement Date",
        EnterLocalAddress: "Enter Local Address",
        EnterPerAddress: "Enter Permanent Address",
        EnterPinCode: "Enter Pin Code",
        AttachedImage: "Attached Image",
        DocManagerReport: "Doc Manager Report",
        SelectSubSubject: " Select Sub Subject",
        SubSubjectName: "Sub Subject Name",
        DivisionName: "Division Name",
        Remark: "Remark",
        SessionYear: "Session Year",
        InActive: "InActive",
        Active: "Active",
        TotalDoc: "Total Document",
        TotalType: "Total Type",
        TotalIndexFile: "Total Index File",
        TotalSplitFile: "Total Split File",
        Zone: "Zone",
        LineChart: "Line Chart",
        Department: "Department",
        AcademicDepartment: "Academic Department",
        DocumentManagementSystem: "Document Management System",
        DocMng: "Document Manager",
        PartNo: "Part Number",
        PeriodFileNo: "Period File Number",
        AuthonticatedPerson: "Authonticated Person",
        FileDate: "File Date",
        SubjectId: "Subject ID",
        ToDate: "To Date",
        MergeToIndexFile: "Merge To Index File",
        MergeToOriginalFile: "Merge To Original File",
        DOB: "Date Of Birth",
        Comment: "Comment",
        DesignationMaster: "Designation Master",

        Date: "Date",
        Type: "Type",
        Time: "Time",
        EmailSystem: "Email System",
        AddEmailsystem: "Create Email System",
        Editemailsystem: "Edit Email System",
        Emaildescription: "Email Description",
        Smsgroup: "Sms group",
        Emailgroup: "Email group",
        Statusactive: "Select Status",
        EmailSetting: "Email Settings ",
        Emailtype: "Type",
        //

        Emailcampaigname: "Enter Campaign Name",
        Emailfromdate: "From Date",
        Emailtodate: "To Date",
        Emailcampgiandate: "Campaign Date",
        Template: "Select Template",
        Type: "Type",
        Totime: "To Time",
        execute: "Save & Execute",
        Emaileventsetting: "Email Event Setting",
        Emaileventtype: "Select Event Type",
        Emaileventname: "Enter Event Name",
        message: "Enter Message",
        // employee
        Employeeinfo: "Employee Info",
        Empname: "Employee Name",
        Employee: "Employee",
        Code: "Code",
        Mobileno: "Mobile No",
        Address: "Address",
        Department: "Department",
        DepartmentName: "Department Name",
        Departmentshortname: "Department Short Name",
        Headofdpt: "Head of Department",

        Designationmaster: "Designation Master",
        DesignationName: "Designation Name",
        DesignationCode: "Designation Code",
        Addesignation: "Create Designation",
        Designation: "Designation",
        DesignationCode: "Designation Code",
        Name: "Name",
        Fathername: "Father Name",
        Mothername: "Mother Name",
        Gender: "Gender",
        DOB: "DOB",
        MobileNo: "MobileNo",
        Email: "Email",
        Panno: "Pan No",
        Aadharno: "Aadhar No",
        joiningdate: "JoiningDate",
        RetirementDate: "RetirementDate",
        Maindetails: "Main Details",
        Signature: "Signature",
        Image: "Image",
        BasicInformation: "Basic Information",
        DrivingLicence: "Driving Licence",
        Department: "Department",
        paddress: "Permanent Address",
        laddress: "Local Address",
        Country: "country",
        State: "State",
        City: "City",
        PinCode: "Pincode",
        editDesignation: "Edit Designation",
        AddDepartment: "Create Department",
        EditDepartment: "Edit Department",

        VehicleNos: "Vehicle No",
        UnderControlOFs: "Under Control OF",
        Departments: "Department",
        Designations: "Designation",

        zoneMaster: "Zone Master",
        add: "ADD",
        Add: "ADD",
        print: "PRINT",
        Print: "Print",
        Active: "Active",
        InActive: "InActive",
        Action: "Action",
        SrNo: "Sr No.",
        zoneName: "Zone Name",
        zoneCode: "Zone Code",
        Status: "Status",
        search: "Search",
        save: "Save",
        reset: "Reset",
        createZoneMaster: "Create Zone Master",
        editZoneMaster: "Edit Zone Master",
        enterZoneName: "Enter Zone Name",
        enterZoneCode: "Enter Zone Code",
        req: "Enter Zone Name required",
        update: "Update",
        wardMaster: "Ward Master",
        wardName: "Ward Name",
        wardCode: "Ward code",
        createWardMaster: "Create Ward Master",
        editWardMaster: "Edit Ward Master",
        enterWardName: "Enter Ward Name",
        enterWardCode: "Enter Ward Code",
        req1: "Enter Ward Name required",
        SelectZoneName: "Select Zone Name ",
        reqSelectZoneName: "Select Zone Name is required",
        CategoryMaster: "Category Master",
        CategoryName: "Category Name",
        EnterCategoryName: "Enter Category Name",
        CreateCategoryMaster: "Create Category Master",
        reqCategory: "Enter Category Name required",
        EditCategoryMaster: "Edit Category Master",
        SubCategoryMaster: "Sub Category Master",
        SubCategoryName: "Sub Category Name",
        RemarkName: "Remark",
        CreateSubCategoryMaster: "Create Sub Category Master",
        EnterSubCategoryName: "Enter Sub Category Name",
        EnterCategoryRemark: "Enter Category Remark",
        reqSelectCategory: "Select Category Required",
        reqEnterSubCategory: "Sub Category Required",
        SelectCategory: "Select Category ",
        EditSubCategoryMaster: "Edit Sub Category Master",
        AdvertiseLocationMaster: "Advertisement Location Master",
        AdvertiseArea: "Advertise Area",
        NearestLocation: "Nearest Location",
        NoOfSites: "No Of Sites",
        latitute: "Latitude",
        longitude: "Longitude",
        CreateAdvertiseLocationMaster: "Create Advertisement Location Master",
        EnterLandmark: "Enter Landmark",
        AttachAdvertiseLocationImage: "Attach Advertisement Location Image",
        selectZone: "Select Zone",
        EditAdvertiseLocationMaster: "Edit Advertisement Location Master",
        FinancialCalendarMaster: "Financial Calendar Master",
        FinancialYear: "Financial Year",
        FromDate: "From Date",
        Todate: "To date",
        CreateFinancialCalendarMaster: "Create Financial Calendar Master",
        ReqEnterFinancialYear: "*Required Enter Financial Year",
        ReqEnterFromDate: "*Required Enter From Date",
        RequiredEnterToDate: "*Required Enter To Date",
        EditFinancialCalendarMaster: "Edit Financial Calendar Master",
        AdvertisementTypeMaster: "Advertisement Type Master",
        AdvertisementName: "Adv. Name",
        rateIsFixed: "Rate Fixed",
        rateType: "Rate Type",
        DayWise: "Day Wise",
        MonthWise: "Month Wise",
        YearWise: "Year Wise",
        createAdvertisementTypeMaster: "Create Advertisement Type Master",
        enterAdvertisementTypeName: "Enter Advertisement Type Name",
        EditAdvertisementTypeMaster: "Edit Advertisement Type Master",
        AdvertisementSubTypeMaster: "Advertisement Sub Type Master",
        SubAdvertisementName: "Sub Adv. Name",
        Description: "Description",
        MaxLength: "Length",
        MaxWidth: "Width",
        MaxHeight: "Height",
        AreaSquareMeter: "Area Sq Mtrs",
        ratePerSqMtr: "Rate/SqMtr",
        Amount: "Amount",
        Premium: "Premium",
        BasePrice: "Base Price",
        CreateSubAdvertisementTypeMaster:
          "Create Sub Advertisement Type Master",
        reqAdvertismentTypeName:
          "Enter Advertisement Type Name should be required",
        EnterSubAdvertisementName: "Enter Sub Advertisement Name",
        EnterDescription: "Enter Description",
        EnterMaxLength: "Enter Max Length (in feet)",
        EnterMaxWidth: "Enter Max Width (in feet)",
        EnterMaxHeight: "Enter Max Height (in feet)",
        EnterAreaSquareMeter: "Enter Area Square Meter",
        EnterRatePerSquareMeter: "Enter Rate Per Square Meter",
        EnterAmount: "Enter Amount",
        EnterPremium: "Enter Premium",
        EnterBasePrice: "Enter Base Price",
        EditSubAdvertisementTypeMaster: "Edit Sub Advertisement Type Master",
        TaxMaster: "Tax Master",
        TaxName: "Tax Name",
        TaxPercentage: "Tax Percentage",
        EffectiveDate: "Effective Date",
        CreateTaxMaster: "Create Tax Master",
        EnterTaxName: "Enter Tax Name",
        EnterTaxPercentage: "Enter Tax Percentage",
        EnterEffectiveDate: "Enter Effective Date",
        reqTaxPercentage: "Tax Percentage must be a positive number",
        reqTaxName: "Tax Name is required",
        reqEffectiveDate: "Effective Date is required",
        EditTaxMaster: "Edit Tax Master",
        MenuMaster: "Menu Master",
        ParentName: "Parent Name",
        MenuName: "Menu Name",
        PageURL: "Page URL",
        Icon: "Icon",
        CreateMenuMaster: "Create Menu Master",
        EnterMenuName: "Enter Menu Name",
        EnterPageURL: "Enter Page URL ",
        EnterIcon: "Enter Icon ",
        selectParentMenuName: "Select Parent Menu Name ",
        reqMenuName: "Menu Name is required",
        EditMenuMaster: "Edit Menu Master",
        RoleMaster: "Role Master",
        RoleName: "Role Name",
        UserPermissionMaster: "User Permission Master",
        UserName: "User Name",
        CountryMaster: "Country Master",
        CountryName: "Country Name",
        CountryCode: "Country Code",
        Nationality: "Nationality",
        CreateCountryName: "Create Country Name",
        EnterCountryName: "Enter Country Name",
        EnterCountryCode: "Enter Country Code",
        EnterNationality: "Enter Nationality",
        EditCountryMaster: "Edit Country Master",
        StateMaster: "State Master",
        StateName: "State Name",
        StateCode: "State Code",
        CreateStateMaster: "Create State Master",
        EnterStateName: "Enter State Name",
        EnterStateCode: "Enter State Code",
        SelectCountryName: "Select Country Name",
        EditStateMaster: "Edit State Master",
        DistrictMaster: "District Master",
        DistrictName: "District Name",
        DistrictCode: "District Code",
        CreateDistrictMaster: "Create District Master",
        EnterDistrictName: "Enter District Name",
        EnterDistrictCode: "Enter District Code",
        SelectDistrictName: "Select District Name",
        EditDistrictMaster: "Edit District Master",
        GenderMaster: "Gender Master",
        GenderName: "Gender Name",
        GenderCode: "Gender Code",
        CreateGenderMaster: "Create Gender Master",
        reqGenderName: "Gender Name  is required",
        EnterGenderName: "Enter Gender Name",
        EnterGenderCode: "Enter Gender Code",
        SelectGenderName: "Select Gender Name",
        EditGenderMaster: "Edit Gender Master",

        UserManegment: "User Management",
        FirstName: "First Name",
        LoginName: "Login Name",
        MobileNo: "Mobile No",
        Email: "Email",
        DateOfBirth: "Date Of Birth",
        Role: "Role",
        SelectGender: "Select Gender",
        SelectRole: "Select Role",
        SelectUserType: "Select UserType",
        CreateUserManegment: "New User ",
        reqFirstName: "First Name Required",
        reqMiddleName: "Middle Name Required",
        reqLastName: "Last Name Required",
        reqloginID: "login ID Required",
        reqPassword: "Password Required",
        reqMobileNumber: "Mobile Number Required",
        reqEmailID: "Email ID Required",
        reqDateofBirth: "Date of Birth Required",
        reqGender: "Gender Required",
        reqUserType: "User Type Required",
        reqRole: "Role Required",
        EnterFirstName: "Enter First Name",
        EnterMiddleName: "Enter Middle Name",
        EnterLastName: "Enter Last Name",
        EnterLoginName: "Enter Login Name",
        EnterPassword: "Enter Password",
        EnterUserCode: "Enter User Code",
        EnterMobileNo: "Enter Mobile No",
        EnterEmailId: "Enter Email-Id",
        EnterDateOfBirth: "Enter Date Of Birth",
        EditUserManegment: "Edit User ",
        UserTypeMaster: "User Type Master",
        EnterUserType: "Enter User Type",
        UserType: "User Type",
        InvalidUserType: "Invalid User Type",
        enterRoleName: "Enter Role Name",
        reqRoleName: "Role Name Required",
        reqcountryName: "Select Country Name Required",
        reqstateName: "State Name Required",
        reqdistrictName: "District Name Required",
        SelectStateName: "Select State Name",
        SelectWard: "Select Area Ward",
        reqAreaName: "Advertise Area is required",
        reqNoOfSites: "No Of Sites is  required",
        reqImg: "Advertise image is required",
        reqAdvertisementTypeID: "Select Advertisement Type Required",
        reqMaxLength: "Length is  Required",
        reqMaxWidth: "Width  is Required",
        reqMaxHeight: "Height is  Required",
        reqRatePerSqMtr: "Rate Square Meter is  Required",
        reqPremium: "Premium Amount is  Required",
        RegisterAgency: "Register Agency / Vendor",
        RenewRegisterAgency: "Renew Register Agency / Vendor",
        ApplyDate: "Apply Date",
        NameOfAgency: "Agency Name",
        ContactNo: "Contact No",
        Address: "Address",
        PANNo: "PAN No",
        AadhaarNo: "Aadhaar No",
        GSTNo: "GST No",
        ApplicationFee: "Application Fee",
        SelectCompanyCategory: "Select Company Category",
        reqAadharNumber: "Aadhar Number Required",
        reqBalanceSheet: "Balance Sheet Required",
        reqAddress: "Address Required",
        reqState: "State Required",
        reqEmail: "Email Required",
        reqDistrict: "District Required",
        reqCompanyCategory: "Company Category Required",
        reqPaymentMode: "Payment Mode Required",
        reqTransactionNumber: "Transaction Number Required",
        DateOfApply: "Date Of Apply",
        EnterRegistrationNo: "Enter Registration No",
        EnterName: "Enter Name",
        EnterContactNo: "Enter Contact No",
        EnterEmailID: "Enter Email ID",
        EnterPANNo: "Enter PAN No",
        EnterGSTNo: "Enter GST No",
        EnterAadharNo: "Enter Aadhar No",
        EnterAddress: "Enter Address",
        EnterApplicationFees: "Enter Application Fees",
        EnterRegistrationFees: "Enter Registration Fees",
        reqEnterRegistrationFees: "Registration Fees Required",
        EnterAgencyName: "Enter Agency name",
        EnterDINNumber: "Enter D.I.N. Number",
        DINNumber: "D. I. N. Number",
        EmailID: "Email ID",

        Yes: "Yes",
        No: "No",

        Preview: "Preview",
        Attach: "Attach",

        Back: "Back",
        Submit: "Submit",
        Next: "Next",
        BasicDetails: "Basic Details",
        AgencyDetails: "Agency Details",
        TermsAndConditions: "Terms and Conditions",
        DocUpload: "Doc Upload",
        reqApproval: "Approval Required",
        ApprovalRegistration: "Approval for Vendor/Agency Registration",
        AlertBeforeApproval:
          "Are you sure? Has all documents been verified before approval",
        EditAgency: "EDIT AGENCY / VENDOR",
        DefaultFinancialYear: "Default Financial Year",
        IsRateFixed: "Is Rate Fixed",
        EnterRateType: "Enter Rate Type",
        RateType: "Rate Type",
        rate: "Rate",
        SelectRateType: "Select Rate Type",
        YouCannotChangeData: "You can not change this data",
        NoDataAvailable: "No data available",
        PaymentDetails: "Payment Details",

        reqName: "Name Required",
        reqAadhaar: "Aadhaar number is required",
        reqAadhaarexactly: "Aadhaar number must be exactly 12 digits",
        reqMobile: "Mobile Number Required",
        reqRegistrationPayment: "Registration Payment Mode Required",
        reqPanNumber: "Pan Number is required",
        reqGSTINnumber: "GSTIN Number is required",
        reqApplyDate: "Apply Date is required",
        reqAlert:
          "Please fill all required fields (Name of Agency, DIN Number, Email ID, and Mobile Number) before adding to the table.",
        validMobile: "is-valid-mobile",
        InvalidMobile: "Invalid mobile number format",
        validEmail: "is-valid-email",
        InvalidEmail: "Invalid email format",
        EnterApplicationTransaction: "Enter Application Transaction Nos.",
        EnterChequeNo: "Enter Application Cheque Nos.",
        EnterCashReceipt: "Enter Application Receipt Nos.",
        EnterNEFT: "Enter Application NEFT Nos.",
        EnterRTGS: "Enter Application RTGS Nos.",
        SelectRegisPaymentMode: "--Select--",
        EnterRegTransaction: "Enter Registration Transaction Nos.",
        EnterRegChequeNo: "Enter Registration Cheque Nos.",
        EnterRegCashReceipt: "Enter Registration Receipt Nos.",
        EnterRegNEFT: "Enter Registration NEFT Nos.",
        EnterRegRTGS: "Enter Registration RTGS Nos.",
        ApplicationFees: "Application Fees",
        SelectRegistrationPaymentMode: "Select Reg. Payment Mode",
        EnterRegistrationTransactionNumber:
          "Enter Registration Transaction Number",
        RegistrationFees: "Reg. Fees",
        Name: "Name",
        reqFirst: "First Name Required",
        reqLast: "Last Name Required",
        reqLogin: "login ID Required",
        reqDate: "Date of Birth Required",
        reqUser: "User Type Required",
        HearingInformation: "Hearing Information",
        action: "action",
        settled: "settled",
        nextHear: "nextHearing",
        repBy: "reported by",
        remDate: "Remainder Date",
        decision: "decision",
        remark: "remark",
        case_status: "case_status",
        fill_date: "fill_date",
        update_status_date: "update_status_date",
        reqCaseNo: "Case No is required",
        reqAction: "Action is required",
        reqNextHear: "Next Hearing  is required",
        reqRepBy: "reported by is required",
        reqRemDate: "Reminder Date is required",
        reqDecision: "Decision is required",
        reqRemark: "Remark is required",
        reqCaseStatus: "Case status is required",
        reqFillDate: "Fill date is required",
        reqUpdateStatusDate: "Update status date is required",
        caseNo: "caseNo",
        CreateHearingInformation: " Create HearingInformation",
        EnterCaseNo: "Enter Case Number",
        EnterAction: "Enter Action",
        EnterRepBy: "Enter Report By",
        EnterDecision: "Enter Decision",
        EnterRemark: "Enter Remark",
        EnterCaseStatus: "Enter case status",
        EnterFillDate: "Enter Fill Date",
        EnterUpdateDate: "Enter Update Date",
        EnterRemDate: "Enter Reminder Date",
        EnterNextHear: "Enter Next Hearing",
        EditHearingInformation: "Edit  Case Hearing Information",
        DefaultYear: "Default Year",
        CaseStageMaster: "Case Stage Master",
        EnterCaseStage: "Enter Case Stage",
        CaseStage: "Case Stage",
        CaseTypeMaster: "Case Type Master",
        EnterCaseType: "Enter Case Type",
        CaseType: "Case Type",
        CaseCategoryMaster: "Case Category Master",
        EnterCaseCategory: "Enter Case Category ",
        CaseCategory: "Case Category ",
        courtTypeMaster: "Court Type Master",
        EnterCourtType: "Enter Court Type",
        CourtType: "Court Type",
        CourtNameMaster: "Court Name Master",
        EnterCourtName: "Enter Court Name",
        CourtName: "Court Name",
        CrimeNatureMaster: "Crime Nature Master",
        EnterCrimeNature: "Enter Crime Nature",
        CrimeNature: "Crime Nature",
        PetitionerPersonalInformation: "Petitioner Personal Information",
        WritNo: " Writ No",
        Casecategory: "Case Category ",
        CounselForPetitioner: "Counsel for Petitioner",
        OICEmail: "officer Incharge Email",
        OICMobile: "officer Incharge Mobile",
        PetitionerName: "Petitioner name",
        CaseDate: "Case Date",
        MobileNumber: "Mobile Number",
        CaseStatus: "Case Status",
        reqCourtType: "Court Type Required",
        reqCaseCategory: "Case Category Required",
        reqCaseType: "Case Type Required",
        reqCourtName: "Court Name Required",
        reqCrimeNature: "Crime Nature Required",
        reqCaseStage: "Case Stage Required",
        SelectCaseType: "Select Case Type",
        SelectCaseCategory: "Select Case Category",
        createPetitioner: " Create Petitioner Personal Information",
        EnterWritNo: "Enter Writ no",
        EnterCounselForPetitioner: "Enter Counsel for Petitioner",
        EnterEmail: "Enter Email",

        deptMaster: "Department Master",
        deptName: "Dept. Name",
        deptCode: "Dept. Code",
        createdeptmaster: " Create Department Master",
        editdeptmaster: "Edit Department Master",
        enterdeptName: "Enter Department Name",
        enterdeptCode: "Enter Department Code",
        reqdept_name: "Department Name Required",
        desName: "Designation Master",
        Designationmastermain: "Designation Master",
        editDesignation: "Edit Designation Master",
        AddDesignation: "Create Designation Master",

        createddesigMAster: "Create Designation Master",
        reqdesignname: "Designation Name Required,",
        enterDesName: "Enter Designation Name",
        entershortCode: " Enter Designation Code",
        selectDet: "Select Department",
        reqdept_id: "Select Department Required",
        editdesMaster: "Edit Designation Master",
        AttachImg: "Attach Transaction Receipt",
        SelectDepartment: "Select Department",
        SelectDesignation: "Select Designation",

        FileClass: "File Class",
        classDescription: "Class Description",
        shortName: "Short Name",
        weedingOutAuthority: "Weeding Out Authority",
        CreateclassDescription: "Create Class Description",
        EnterShortName: "Enter Short Name",
        EnterClassDescription: "Enter Class Description",
        EnterWeedingOutAuthority: "Enter Weeding Authority ",
        CreateFileClass: "Create File Class",
        EditFileClass: "Edit File Class",
        FileGroupName: "File Group Name",
        EnterFileGroupName: "Enter File Group Name",
        FileGroup: "File Group",
        FileSubject: "File Subject",
        EnterFileSubjectName: " Enter File Subject Name",
        FileSubjectName: "File Subject Name",
        // ShortName: "Short Name",
        FileType: "File Type",
        EnterFileTypeName: "Enter File Type Name",
        FileTypeName: "File Type Name ",
        SelectFileGroup: "Select File Group",
        SelectFileCategory: "Select File Category",
        SelectFileType: "Select File Type",
        SelectFileNo: "Select File Number",
        SelectFileClass: " Select File Class",
        SelectFileSubject: "Select File Subject",
        ReceiptStatus: "Receipt Status",
        RecName: "Receipt Name",
        EnterRecName: "Enter Receipt Name",
        ReceiptType: "Receipt Type",
        ReceiptName: "Receipt Name",
        EnterReceiptName: "Enter Receipt Name",
        RecStatus: "Receipt Status",
        EnterRecStatus: "Enter Receipt Status",
        reqRecStatus: "Require Receipt Status ",
        Location: "Location",
        LocationName: "Location Name",
        EnterLocationName: "Enter Location Name",
        LocationShortName: " Location Short Name",
        EnterLocationShortName: "Enter Location Short Name",
        senderID: "Sender ID",
        receiverID: " Recever ID",
        currentLocation: " Current Location",
        EnterSignatureUpload: "Attach Signature",
        EnterLocationObject: "Enter Location Object",
        EnterAbbreviation: "Enter Abbreviation",
        Abbreviation: "Abbreviation",
        LocationObject: "Location Object",
        reqLocationObject: "Require Location Object ",
        reqFileGroupName: "Require File Group Name",
        reqFileSubjectName: "Require File Subject Name",
        reqFileTypeName: "Require File Type Name",
        reqReceiptName: "Require Receipt Name",
        EnterDocUpload: "Attach Document",
        EnterDocSubType: "Doc Subject Type",
        EnterSubDocAbbreviation: "Doc Subject Abbreviation",
        SelectDoctype: "Select Doc Type",
        SelectFileName: "Select file Name",
        SelectSubject: "Select Subject",
        EnterSubFtype: "subject file type",
        SelectDivision: "Select Division",
        EnterCountryShortName: " Enter Country Short Name",
        EnterStateShortName: "Enter State Short Name",
        EnterdisplayNo: "Enter Display Number",
        SelectDocType: "Select Doc Type",
        enterDesCode: "Enter Designation Code",
        DesignationName: "Designation Name",
        DesignationCode: "Designation Code",
        DocType: "Document Type",
        DocSubType: "Document Sub Type",
        CreateDocType: "Create Doc Type",
        EditDocType: "Edit Doc Type",
        EnterDocType: "Enter Doc Type",
        EntryDate: "Entry Date",
        EnterDocName: "Enter Doc Name",
        DocSubject: "Doc Subject",
        Subject: "Subject",
        DocSubSubject: "Doc Sub Subject",
        SubSubject: "Sub Subject",
        FileNo: "File Number",
        Synopsis: "Synopsis",
        FileDef: "File Definition",
        DocumentEntry: "Document Entry",
        DocumentEntryAdd: "Add Document Entry ",
        reqFileNo: "File No Is Require",
        EnterFileNo: "Enter File Number",
        EnterSynopsis: "Enter Synopsis",
        EnterPartNo: "Enter Part Number",
        EnterPeriodFileUpto: "Enter Period File Upto",
        EnterSubject: "Enter Subject",
        EnterFileDef: "Enter File Definition",
        EnterComplete: "Enter Complete",
        EnterAuthenticatePerson: "Enter Authenticated Person",
        EnterFileDate: "Enter File Date",
        SelectFile: "Select File",
        SelectSubject: "Select Subject",
        SelectDivision: "Select Division",
        EnterPeriodDate: "Enter Period Date",
        AttachedFile: "Attached File",
        EnterFileName: "Enter File Name",
        PeriodDate: "Period Date",
        Keywords: "Keywords",
        FileName: "File Name",
        PdfFile: "PDF File",
        DocumentEntryEdit: "Edit Document Entry ",
        EnterKeyword: "Enter Keyword",
        PdfName: "PDF Name",
        DocFiles: "Document Files",
        SelectDoc: "Select Doc",
        SelectLocation: "Select Location",
        reqPdfName: "PDF Name Is Require",
        CreateDocFiles: "Create Document Files",
        EditDocFiles: "Edit Document Files",
        EnterPdfName: "Enter PDF Name",
        EnterKeywords: "Enter Keywords",
        EnterSubFtype: "Enter Sub File Type",
        EnterPdfDate: "Enter PDF Date",
        DocPages: "Doc Pages",
        Comments: "Comments",
        PhysicalSerialNo: "Physical Serial Number",
        PhysicalIndex: "Physical Index",
        CreateDocPages: "Create Doc Pages",
        EditDocPages: "Edit Doc Pages",
        PageNoFrom: "Page Number From",
        PageNoUpto: "Page Number Upto",
        EnterComments: "Enter Comments",
        EnterPhysicalSerialNo: "Enter Physical Serial Number",
        EnterPhysicalIndex: "Enter Physical Index",
        SelectField: "Select Field",
        DocViewer: "Document Viewer",
        SubFileType: "Sub File Type",
        ViewPdf: "View PDF",
        View: "View",
        NoRecordAvailable: "No Record Available",
        NoPdfAvailable: "No PDF Available",
        AddComment: "Add Comment",
        PageNoFrom: "Page Number From",
        PageNoTo: "Page Number To",
        RelatedOficer: "Related Oficer",
        AddRow: "Add Row",
        Index: "Index!",
        SelectDevision: "Select Devision",
        SelectFileStatus: "Select File Status",
        DocumentIndexing: "Document Indexing",
        Filter: "Filter",
        Print: "Print",
        PeriodFrom: "Period From",
        PeriodTo: "Period To",
        Search: "Search",
        Clear: "Clear",
        ViewIndexPdf: "View Index PDF",
        ViewFullPdf: "View Full PDF",
        FileDefinition: "File Definition",
        SearchKeywords: "Search Keywords",
        DateFrom: "Date From",
        DateTo: "Date To",
        Complete: "Complete",
        SplitPdfToJump: "Split PDF To Jump",
        SplitPage: "Split Page",
        PdfFileName: "PDF File Name",
        PageFrom: "Page From",
        PageTo: "Page To",
        ViewFile: "View File",
        AddPdf: "Add PDF",
        DocUpload: "Document Upload",
        EnterRemark: "Enter Remark",
        EnterValue: "Enter Value",
        FileSaved: "File Saved",
        EnterMainPdf: "Enter Main PDF",
        EnterPdf: "Enter PDF",
        PdfMearge: "PDF Mearge",
        SplitMainFile: "Split Main File",
        ForRename: "For Rename",
        ForShiftCategory: "For Shift Category",
        UpdatePdf: "Update PDF",
        PdfCounter: "PDF Counter",
        EnterFolderPath: "Enter Folder Path",
        Count: "Count",
        EmployeeEntry: "Employee Entry",
        EmployeeName: "Employee Name",
        Login: "Login",
        Password: "Password",
        Edit: "Edit",
        delete: "Delete",
        Export: "Export",
        Release: "Release",
        Post: "Post",
        SelectEmployeeName: "Select Employee Name",
        ParentName: "Parent Name",
        EmployeeMaster: "Employee Master",
        EmpName: "Employee Name",
        EmpCode: "Employee Code",
        EmpStatus: "Employee Status",
        SelectState: "Select State",
        SelectCountry: "Select Country",
        SelectDistrict: "Select District",
        reqEmpName: "Employee name Is Require",
        reqEmpCode: "Employee Code is Require",
        reqFatherName: "Father Name Is Require",
        reqMobNo: "Mobile Number Is Require",
        reqPanNo: "Pan Number Is Require",
        reqJoiningDate: "Joining Date Is Require",
        reqDesignation: "Designation Is Require",
        reqDepartment: "Department Is Require",
        reqPerAddress: "Permanent Address Is Require",
        reqPinCode: "Pin Code Is Require",
        reqAdharNo: "Adhar Number Is Require",
        reqEmail: "Email Is Require",
        reqEmpdob: "Employee DOB Is Required",
        CreateEmployeeReg: "Create Employee Registration",
        EditEmployeeReg: "Edit Employee Registration",
        EnterEmpName: "Enter Employee Name",
        EnterEmpCode: "Enter Employee Code",
        EnterFatherName: "Enter Father Name",
        EnterSpauseName: "Enter Spouse Name",
        EnterMotherName: "Enter Mother Name",
        EnterMobileNumber: "Enter Mobile Number",
        EnterEmail: "Enter Email",
        EnterPanNo: "Enter Pan Number",
        EnterAdharNo: "Enter Adhar Number",
        EnterDOB: "Enter Date Of Birth",
        EnterJoiningDate: "Enter Joining Date",
        EnterRetirementDate: "Enter Retirement Date",
        EnterLocalAddress: "Enter Local Address",
        EnterPerAddress: "Enter Permanent Address",
        EnterPinCode: "Enter Pin Code",
        AttachedImage: "Attached Image",
        DocManagerReport: "Doc Manager Report",
        SelectSubSubject: " Select Sub Subject",
        SubSubjectName: "Sub Subject Name",
        DivisionName: "Division Name",
        Remark: "Remark",
        SessionYear: "Session Year",
        InActive: "InActive",
        Active: "Active",
        TotalDoc: "Total Document",
        TotalType: "Total Type",
        TotalIndexFile: "Total Index File",
        TotalSplitFile: "Total Split File",
        Zone: "Zone",
        LineChart: "Line Chart",
        Department: "Department",
        AcademicDepartment: "Academic Department",
        DocumentManagementSystem: "Document Management System",
        DocMng: "Document Manager",
        PartNo: "Part Number",
        PeriodFileNo: "Period File Number",
        AuthonticatedPerson: "Authonticated Person",
        FileDate: "File Date",
        SubjectId: "Subject ID",
        ToDate: "To Date",
        MergeToIndexFile: "Merge To Index File",
        MergeToOriginalFile: "Merge To Original File",
        DOB: "Date Of Birth",
        Comment: "Comment",
        DesignationMaster: "Designation Master",

        enteritemType: "Enter Item Type",
        enteritemTypecode: "Enter Item Type Code",
        itemType: "Item Type",
        itemTypecode: "Item Type Code",
        ItemType: "Item Type",
        entertaxName: "Enter Tax Name",
        entertaxPercentage: "Enter Tax Percentage",
        entereffectiveDate: "Enter Effective Date",
        taxName: "Tax Name",
        taxPercentage: "Tax Percentage",
        effectiveDate: "Effective Date",
        TaxMaster: "Tax Master",
        unitName: "Unit Name",
        unitShortname: "Unit Short Name",
        UnitMaster: "Unit Master",
        enterunitName: "Enter Unit Name",
        enterunitShortname: "Enter Unit Short Name",
        enteritemName: "Enter Item Name",
        enteritemCode: "Enter Item Code",
        enteritemTypeId: "Enter Item Type ID",
        enterempId: "Enter Employee ID",
        entertaxId: "Enter Tax ID",
        itemCategory: "Enter Item Category",
        enterunitId: "Enter Unit ID",
        entermodelNo: "Enter Model No",
        enterserialNo: "Enter Serial No",
        entervehicleNo: "Enter Vehicle No",
        enterchesisNo: "Enter Chesis No",
        enterhsnCode: "Enter hsn Code",
        enteritemWeight: "Enter Item Weight",
        enterdepreciationRate: "Enter Depreciation Rate",
        enterpurchaseYear: "Enter Purchase Year",
        itemName: "Item Name",
        itemCode: "Item Code",
        purchaseYear: "Purchase Year",
        modelNo: "ModelNo",
        serialNo: "SerialNo",
        vehicleNo: "VehicleNo",
        hsnCode: "HSN Code",
        itemWeight: "Item Weight",
        ItemMaster: "Item Master",
        Purchaseorder: "Purchase Order",
        entryNo: "EntryNo",
        batchNo: "Batch Number",
        itemId: "ItemId",
        unitID: "UnitId",
        rate: "Rate",
        inQty: "inQty",
        outQty: "outQty",
        voucherId: "VoucherId",
        stockBinId: "StockBinId",
        voucherType: "Voucher Type",
        voucherDate: "Voucher Date",
        expiryDate: "Expiry Date",
        companyId: "CompanyId",
        gstRate: "gstRate",
        cgst: "cgst",
        sgst: "sgst",
        igst: "igst",
        gstid: "gstid",
        cgstid: "cgstid",
        sgstid: "sgstid",
        igstid: "igstid",
        StockLedger: "StockLedger",
        enterentryNo: "Enter EnteryNo",
        enterbatchNo: "Entery BatchNo",
        enteritemId: "Enter ItemId",
        enterunitID: "Enter UnitId",
        enterrate: "Enter Rate",
        enterinQty: "Enter InQty ",
        enteroutQty: "Enter outQty",
        entervoucherId: "Enter VoucherId",
        entervoucherType: "Enter Voucher Type",
        entervoucherDate: "Enter Voucher Date",
        enterexpiryDate: "Enter Expiry Date",
        entergstRate: "Enter gstRate ",
        entercgst: "Enter CGST",
        entersgst: "Enter sgst",
        enterigst: "Enter igst",
        entergstid: "Enter gstid",
        entersgstid: "Enter sgstid",
        enterigstid: "Enter igstid",
        itemCategory: "itemCategory",
        itemCategoryAbbre: "ItemCategoryAbbre",
        parentId: "ParentId",
        taxId: "TaxId",
        enteritemCategory: "Enter Item Category",
        enteritemCategoryAbbre: "Enter Item CategoryAbbre",
        entertaxId: "Enter TaxId",
        enterparentId: "Enter ParentId",
        ItemCategory: "ItemCategory",

        JurisdictionMaster: "Jurisdiction Master",
        EnterJurisdictionName: "Enter Jurisdiction Name",
        SelectNode: "Select Node",
        NodePermission: "Node Permission",
        SelectUser: "Select User",
        PollMaster: "Pole Master",
        CreatePollMaster: "Create Poll Master",
        poleName: "Pole Name",
        SelectPollType: "Select Poll Type",
        Hight: "Hight",
        wight: "Weight",
        Thickness: "Thickness",
        poleColor: "Pole Color",
        underGroundPoleHight: "Under Ground Pole Hight",
        numOfLightAttach: "Number Of Light Attach",
        currentStatus: "Current Status",
        poleImg: "Pole Image",
        EditPollMaster: "Edit Poll Master",

        PoleType: "Pole Type",
        PoleTypeName: "Pole Type Name",

        //Inventory Module
        CreateIndent: "Create Indent",
        EditIndent: "Edit Indent",
        estimateNo: "Enter Estimate No",
        emp_name: "Enter Employee Name",
        indentDate: "Select Indent Date",

        // email system
        EmailSystem: "Email System",

        //  VTS dashboard And Report

        ToDate: "To Date",
        MergeToIndexFile: "Merge To Index File",
        MergeToOriginalFile: "Merge To Original File",
        DOB: "Date Of Birth",
        Comment: "Comment",
        Dashboard: "Dashboard",
        Tracking: "Tracking",
        GeofacingCreate: "Geofacing Create",
        KudagharLocation: "Kudaghar Location",
        VehicleHistory: "Vehicle History",
        VehicleTravelled: "Vehicle Travelled",
        VehicleNotMoved: "Vehicle Not Moved",
        VehicleDetailsSummery: "Vehicle Details Summery",
        ProbableWireTempering: "Probable Wire Tempering",
        FuelConsumption: "Fuel Consumption",
        FuelConspWithoughtOpening: "Fuel Consumption Withought Opening",
        FuelConspWithOpening: "Fuel Consumption With Opening",
        VehicleTrack: "Vehicle Track",
        Period: "Period",
        VehicleType: "Vehicle Type",
        VehicleNo: "Vehicle Number",
        Latitute: "Latitude",
        Longitude: "Longitude",
        Radius: "Radius",
        FenceName: "Fence Name",
        TrackingDate: "Tracking Date",
        Speed: "Speed",
        HelpDesk: "Help Desk",
        HelpCreation: "Help Creation",
        PageTitle: "Page Title",

        // DepartmentName:'Department Name',
        Date: "Date",
        Devid: "Devid",
        TrackTime: "Track Time",
        kmPerLitre: "km Per Litre",
        Ignition: "Ignition",
        Distance: "Distance",
        FuelConsumed: "Fuel Consumed",
        Duration: "Duration",
        Driver: "Driver",

        DepartmentName: "Department Name",
        Date: "Date",
        Devid: "Devid",
        TrackTime: "Track Time",
        kmPerLitre: "km Per Litre",
        Ignition: "Ignition",
        Distance: "Distance",
        FuelConsumed: "Fuel Consumed",
        Duration: "Duration",
        Driver: "Driver",
        Polygon: "Polygon",
        Running: "Running",
        Idle: "Idle",
        StartTime: "Start Time",
        EndTime: "End Time",
        BinLocation: "Bin Location",

        DistanceKm: "Distance(Km)",
        avgSpeed: "Avg. Speed",
        TimeConsuption: "Time Consuption",
        MileageKmLtr: "Mileage(Km/Ltr)",
        FuelAlloted: "Fuel Alloted",
        TotFuelAllot: "Total Fuel Alloted",
        TotalDays: "Total Days",
        DistanceAlloted: "Distance Alloted",
        ActualDistance: "Actual Distance",
        DistanceAlloted: "Distance Alloted",
        BalanceDist: "Balance Dist",
        BalanceFuel: "Balance Fuel",

        //
        //complain
        SelectpoleNo: "Select Pole Number",
        compainStatus: "Complaint Status",
        compType: "Select Complaint Type",
        approveEmployee3: "Select Approve Employee 3",
        approveEmployee2: "Select Approve Employee 2",
        //roster group
        groupName: "Enter Group Name",
        wardId: "Select Ward Name",
        zoneId: "Select Zone Name",
        groupDate: "Select Group Date",
        CreateRosterGroup: "Create Roster Group",
        EditRosterGroup: "Edit Roster Group",
        RosterGroup: "Roster Group",
        selectemployee: "Select Employee",
        groupName1: "Group Name",
        wardId1: "Ward Id",
        groupDate1: "Group Date",

        issueDate: "Issue Date",
        empName: "Employee Name",
        //staff item return
        SelectReturnIndentno: "Select Return Indent No",
        //grid
        returnType: "Return Type",
        returnIndentNo: "Return Indent No",
        editStaffIndent: "Edit Staff Indent",
        approveQuantity: "Approve Quantity",
        quantity: "Quantity",
        IndentNO: "Indent Number",
        selectemp_name: "Select Employee Name",
        Remark1: "Remark",
        zoneMaster: "Zone Master",
        add: "ADD",
        Add: "ADD",
        print: "PRINT",
        Print: "Print",
        Active: "Active",
        InActive: "InActive",
        Action: "Action",
        SrNo: "Sr No.",
        zoneName: "Zone Name",
        zoneCode: "Zone Code",
        Status: "Status",
        search: "Search",
        save: "Save",
        reset: "Reset",
        createZoneMaster: "Create Zone Master",
        editZoneMaster: "Edit Zone Master",
        enterZoneName: "Enter Zone Name",
        enterZoneCode: "Enter Zone Code",
        req: "Enter Zone Name required",
        update: "Update",
        wardMaster: "Ward Master",
        wardName: "Ward Name",
        wardCode: "Ward code",
        createWardMaster: "Create Ward Master",
        editWardMaster: "Edit Ward Master",
        enterWardName: "Enter Ward Name",
        enterWardCode: "Enter Ward Code",
        req1: "Enter Ward Name required",
        SelectZoneName: "Select Zone Name ",
        reqSelectZoneName: "Select Zone Name is required",
        CategoryMaster: "Category Master",
        CategoryName: "Category Name",
        EnterCategoryName: "Enter Category Name",
        CreateCategoryMaster: "Create Category Master",
        reqCategory: "Enter Category Name required",
        EditCategoryMaster: "Edit Category Master",
        SubCategoryMaster: "Sub Category Master",
        SubCategoryName: "Sub Category Name",
        RemarkName: "Remark",
        CreateSubCategoryMaster: "Create Sub Category Master",
        EnterSubCategoryName: "Enter Sub Category Name",
        EnterCategoryRemark: "Enter Category Remark",
        reqSelectCategory: "Select Category Required",
        reqEnterSubCategory: "Sub Category Required",
        SelectCategory: "Select Category ",
        EditSubCategoryMaster: "Edit Sub Category Master",
        AdvertiseLocationMaster: "Advertisement Location Master",
        AdvertiseArea: "Advertise Area",
        NearestLocation: "Nearest Location",
        NoOfSites: "No Of Sites",
        latitute: "Latitude",
        longitute: "Longitude",
        CreateAdvertiseLocationMaster: "Create Advertisement Location Master",
        EnterLandmark: "Enter Landmark",
        AttachAdvertiseLocationImage: "Attach Advertisement Location Image",
        selectZone: "Select Zone",
        EditAdvertiseLocationMaster: "Edit Advertisement Location Master",
        FinancialCalendarMaster: "Financial Calendar Master",
        FinancialYear: "Financial Year",
        FromDate: "From Date",
        Todate: "To date",
        CreateFinancialCalendarMaster: "Create Financial Calendar Master",
        ReqEnterFinancialYear: "*Required Enter Financial Year",
        ReqEnterFromDate: "*Required Enter From Date",
        RequiredEnterToDate: "*Required Enter To Date",
        EditFinancialCalendarMaster: "Edit Financial Calendar Master",
        AdvertisementTypeMaster: "Advertisement Type Master",
        AdvertisementName: "Adv. Name",
        rateIsFixed: "Rate Fixed",
        rateType: "Rate Type",
        DayWise: "Day Wise",
        MonthWise: "Month Wise",
        YearWise: "Year Wise",
        createAdvertisementTypeMaster: "Create Advertisement Type Master",
        enterAdvertisementTypeName: "Enter Advertisement Type Name",
        EditAdvertisementTypeMaster: "Edit Advertisement Type Master",
        AdvertisementSubTypeMaster: "Advertisement Sub Type Master",
        SubAdvertisementName: "Sub Adv. Name",
        Description: "Description",
        MaxLength: "Length",
        MaxWidth: "Width",
        MaxHeight: "Height",
        AreaSquareMeter: "Area Sq Mtrs",
        ratePerSqMtr: "Rate/SqMtr",
        Amount: "Amount",
        Premium: "Premium",
        BasePrice: "Base Price",
        CreateSubAdvertisementTypeMaster:
          "Create Sub Advertisement Type Master",
        reqAdvertismentTypeName:
          "Enter Advertisement Type Name should be required",
        EnterSubAdvertisementName: "Enter Sub Advertisement Name",
        EnterDescription: "Enter Description",
        EnterMaxLength: "Enter Max Length (in feet)",
        EnterMaxWidth: "Enter Max Width (in feet)",
        EnterMaxHeight: "Enter Max Height (in feet)",
        EnterAreaSquareMeter: "Enter Area Square Meter",
        EnterRatePerSquareMeter: "Enter Rate Per Square Meter",
        EnterAmount: "Enter Amount",
        EnterPremium: "Enter Premium",
        EnterBasePrice: "Enter Base Price",
        EditSubAdvertisementTypeMaster: "Edit Sub Advertisement Type Master",
        TaxMaster: "Tax Master",
        TaxName: "Tax Name",
        TaxPercentage: "Tax Percentage",
        EffectiveDate: "Effective Date",
        CreateTaxMaster: "Create Tax Master",
        EnterTaxName: "Enter Tax Name",
        EnterTaxPercentage: "Enter Tax Percentage",
        EnterEffectiveDate: "Enter Effective Date",
        reqTaxPercentage: "Tax Percentage must be a positive number",
        reqTaxName: "Tax Name is required",
        reqEffectiveDate: "Effective Date is required",
        EditTaxMaster: "Edit Tax Master",
        totalTax: "GST Ammount",
        MenuMaster: "Menu Master",
        ParentName: "Parent Name",
        MenuName: "Menu Name",
        PageURL: "Page URL",
        Icon: "Icon",
        CreateMenuMaster: "Create Menu Master",
        EnterMenuName: "Enter Menu Name",
        EnterPageURL: "Enter Page URL ",
        EnterIcon: "Enter Icon ",
        selectParentMenuName: "Select Parent Menu Name ",
        reqMenuName: "Menu Name is required",
        EditMenuMaster: "Edit Menu Master",
        RoleMaster: "Role Master",
        RoleName: "Role Name",
        UserPermissionMaster: "User Permission Master",
        UserName: "User Name",
        CountryMaster: "Country Master",
        CountryName: "Country Name",
        CountryCode: "Country Code",
        Nationality: "Nationality",
        CreateCountryName: "Create Country Name",
        EnterCountryName: "Enter Country Name",
        EnterCountryCode: "Enter Country Code",
        EnterNationality: "Enter Nationality",
        EditCountryMaster: "Edit Country Master",
        StateMaster: "State Master",
        StateName: "State Name",
        StateCode: "State Code",
        CreateStateMaster: "Create State Master",
        EnterStateName: "Enter State Name",
        EnterStateCode: "Enter State Code",
        SelectCountryName: "Select Country Name",
        EditStateMaster: "Edit State Master",
        DistrictMaster: "District Master",
        DistrictName: "District Name",
        DistrictCode: "District Code",
        CreateDistrictMaster: "Create District Master",
        EnterDistrictName: "Enter District Name",
        EnterDistrictCode: "Enter District Code",
        SelectDistrictName: "Select District Name",
        EditDistrictMaster: "Edit District Master",
        GenderMaster: "Gender Master",
        GenderName: "Gender Name",
        GenderCode: "Gender Code",
        CreateGenderMaster: "Create Gender Master",
        reqGenderName: "Gender Name  is required",
        EnterGenderName: "Enter Gender Name",
        EnterGenderCode: "Enter Gender Code",
        SelectGenderName: "Select Gender Name",
        EditGenderMaster: "Edit Gender Master",
        UserManegment: "User Management",
        FirstName: "First Name",
        LoginName: "Login Name",
        mobileNo: "Mobile No",
        Email: "Email",
        DateOfBirth: "Date Of Birth",
        Role: "Role",
        SelectGender: "Select Gender",
        SelectRole: "Select Role",
        SelectUserType: "Select UserType",
        CreateUserManegment: "New User ",
        reqFirstName: "First Name Required",
        reqMiddleName: "Middle Name Required",
        reqLastName: "Last Name Required",
        reqloginID: "login ID Required",
        reqPassword: "Password Required",
        reqMobileNumber: "Mobile Number Required",
        reqEmailID: "Email ID Required",
        reqDateofBirth: "Date of Birth Required",
        reqGender: "Gender Required",
        reqUserType: "User Type Required",
        reqRole: "Role Required",
        EnterFirstName: "Enter First Name",
        EnterMiddleName: "Enter Middle Name",
        EnterLastName: "Enter Last Name",
        EnterLoginName: "Enter Login Name",
        EnterPassword: "Enter Password",
        EnterUserCode: "Enter User Code",
        EntermobileNo: "Enter Mobile No",
        EnterEmailId: "Enter Email-Id",
        EnterDateOfBirth: "Enter Date Of Birth",
        EditUserManegment: "Edit User ",
        UserTypeMaster: "User Type Master",
        EnterUserType: "Enter User Type",
        UserType: "User Type",
        InvalidUserType: "Invalid User Type",
        enterRoleName: "Enter Role Name",
        reqRoleName: "Role Name Required",
        reqcountryName: "Select Country Name Required",
        reqstateName: "State Name Required",
        reqdistrictName: "District Name Required",
        SelectStateName: "Select State Name",
        SelectWard: "Select Area Ward",
        reqAreaName: "Advertise Area is required",
        reqNoOfSites: "No Of Sites is  required",
        reqImg: "Advertise image is required",
        reqAdvertisementTypeID: "Select Advertisement Type Required",
        reqMaxLength: "Length is  Required",
        reqMaxWidth: "Width  is Required",
        reqMaxHeight: "Height is  Required",
        reqRatePerSqMtr: "Rate Square Meter is  Required",
        reqPremium: "Premium Amount is  Required",
        RegisterAgency: "Register Agency / Vendor",
        RenewRegisterAgency: "Renew Register Agency / Vendor",
        ApplyDate: "Apply Date",
        NameOfAgency: "Agency Name",
        ContactNo: "Contact No",
        Address: "Address",
        PANNo: "PAN No",
        AadhaarNo: "Aadhaar No",
        GSTNo: "GST No",
        ApplicationFee: "Application Fee",
        SelectCompanyCategory: "Select Company Category",
        reqAadharNumber: "Aadhar Number Required",
        reqBalanceSheet: "Balance Sheet Required",
        reqAddress: "Address Required",
        reqState: "State Required",
        reqEmail: "Email Required",
        reqDistrict: "District Required",
        reqCompanyCategory: "Company Category Required",
        reqPaymentMode: "Payment Mode Required",
        reqTransactionNumber: "Transaction Number Required",
        DateOfApply: "Date Of Apply",
        EnterRegistrationNo: "Enter Registration No",
        EnterName: "Enter Name",
        EnterContactNo: "Enter Contact No",
        EnterEmailID: "Enter Email ID",
        EnterPANNo: "Enter PAN No",
        EnterGSTNo: "Enter GST No",
        EnterAadharNo: "Enter Aadhar No",
        EnterAddress: "Enter Address",
        EnterApplicationFees: "Enter Application Fees",
        EnterRegistrationFees: "Enter Registration Fees",
        reqEnterRegistrationFees: "Registration Fees Required",
        EnterAgencyName: "Enter Agency name",
        EnterDINNumber: "Enter D.I.N. Number",
        DINNumber: "D. I. N. Number",
        EmailID: "Email ID",
        Yes: "Yes",
        No: "No",
        Preview: "Preview",
        Attach: "Attach",
        Back: "Back",
        Submit: "Submit",
        Next: "Next",
        BasicDetails: "Basic Details",
        AgencyDetails: "Agency Details",
        TermsAndConditions: "Terms and Conditions",
        DocUpload: "Doc Upload",
        reqApproval: "Approval Required",
        ApprovalRegistration: "Approval for Vendor/Agency Registration",
        AlertBeforeApproval:
          "Are you sure? Has all documents been verified before approval",
        EditAgency: "EDIT AGENCY / VENDOR",
        DefaultFinancialYear: "Default Financial Year",
        IsRateFixed: "Is Rate Fixed",
        EnterRateType: "Enter Rate Type",
        RateType: "Rate Type",
        rate: "Rate",
        SelectRateType: "Select Rate Type",
        YouCannotChangeData: "You can not change this data",
        NoDataAvailable: "No data available",
        PaymentDetails: "Payment Details",
        reqName: "Name Required",
        reqAadhaar: "Aadhaar number is required",
        reqAadhaarexactly: "Aadhaar number must be exactly 12 digits",
        reqMobile: "Mobile Number Required",
        reqRegistrationPayment: "Registration Payment Mode Required",
        reqPanNumber: "Pan Number is required",
        reqGSTINnumber: "GSTIN Number is required",
        reqApplyDate: "Apply Date is required",
        reqAlert:
          "Please fill all required fields (Name of Agency, DIN Number, Email ID, and Mobile Number) before adding to the table.",
        validMobile: "is-valid-mobile",
        InvalidMobile: "Invalid mobile number format",
        validEmail: "is-valid-email",
        InvalidEmail: "Invalid email format",
        EnterApplicationTransaction: "Enter Application Transaction Nos.",
        EnterChequeNo: "Enter Application Cheque Nos.",
        EnterCashReceipt: "Enter Application Receipt Nos.",
        EnterNEFT: "Enter Application NEFT Nos.",
        EnterRTGS: "Enter Application RTGS Nos.",
        SelectRegisPaymentMode: "--Select--",
        EnterRegTransaction: "Enter Registration Transaction Nos.",
        EnterRegChequeNo: "Enter Registration Cheque Nos.",
        EnterRegCashReceipt: "Enter Registration Receipt Nos.",
        EnterRegNEFT: "Enter Registration NEFT Nos.",
        EnterRegRTGS: "Enter Registration RTGS Nos.",
        ApplicationFees: "Application Fees",
        SelectRegistrationPaymentMode: "Select Reg. Payment Mode",
        EnterRegistrationTransactionNumber:
          "Enter Registration Transaction Number",
        RegistrationFees: "Reg. Fees",
        Name: "Name",
        reqFirst: "First Name Required",
        reqLast: "Last Name Required",
        reqLogin: "login ID Required",
        reqDate: "Date of Birth Required",
        reqUser: "User Type Required",
        HearingInformation: "Hearing Information",
        action: "action",
        settled: "settled",
        nextHear: "nextHearing",
        repBy: "reported by",
        remDate: "Remainder Date",
        decision: "decision",
        remark1: "remark",
        case_status: "case_status",
        fill_date: "fill_date",
        update_status_date: "update_status_date",
        reqCaseNo: "Case No is required",
        reqAction: "Action is required",
        reqNextHear: "Next Hearing  is required",
        reqRepBy: "reported by is required",
        reqRemDate: "Reminder Date is required",
        reqDecision: "Decision is required",
        reqRemark: "Remark is required",
        reqCaseStatus: "Case status is required",
        reqFillDate: "Fill date is required",
        reqUpdateStatusDate: "Update status date is required",
        caseNo: "caseNo",
        CreateHearingInformation: " Create HearingInformation",
        EnterCaseNo: "Enter Case Number",
        EnterAction: "Enter Action",
        EnterRepBy: "Enter Report By",
        EnterDecision: "Enter Decision",
        EnterRemark: "Enter Remark",
        EnterCaseStatus: "Enter case status",
        EnterFillDate: "Enter Fill Date",
        EnterUpdateDate: "Enter Update Date",
        EnterRemDate: "Enter Reminder Date",
        EnterNextHear: "Enter Next Hearing",
        EditHearingInformation: "Edit  Case Hearing Information",
        DefaultYear: "Default Year",
        CaseStageMaster: "Case Stage Master",
        EnterCaseStage: "Enter Case Stage",
        CaseStage: "Case Stage",
        CaseTypeMaster: "Case Type Master",
        EnterCaseType: "Enter Case Type",
        CaseType: "Case Type",
        CaseCategoryMaster: "Case Category Master",
        EnterCaseCategory: "Enter Case Category ",
        CaseCategory: "Case Category ",
        courtTypeMaster: "Court Type Master",
        EnterCourtType: "Enter Court Type",
        CourtType: "Court Type",
        CourtNameMaster: "Court Name Master",
        EnterCourtName: "Enter Court Name",
        CourtName: "Court Name",
        CrimeNatureMaster: "Crime Nature Master",
        EnterCrimeNature: "Enter Crime Nature",
        CrimeNature: "Crime Nature",
        PetitionerPersonalInformation: "Petitioner Personal Information",
        WritNo: " Writ No",
        Casecategory: "Case Category ",
        CounselForPetitioner: "Counsel for Petitioner",
        OICEmail: "officer Incharge Email",
        OICMobile: "officer Incharge Mobile",
        PetitionerName: "Petitioner name",
        CaseDate: "Case Date",
        MobileNumber: "Mobile Number",
        CaseStatus: "Case Status",
        reqCourtType: "Court Type Required",
        reqCaseCategory: "Case Category Required",
        reqCaseType: "Case Type Required",
        reqCourtName: "Court Name Required",
        reqCrimeNature: "Crime Nature Required",
        reqCaseStage: "Case Stage Required",
        SelectCaseType: "Select Case Type",
        SelectCaseCategory: "Select Case Category",
        createPetitioner: " Create Petitioner Personal Information",
        EnterWritNo: "Enter Writ no",
        EnterCounselForPetitioner: "Enter Counsel for Petitioner",
        EnterEmail: "Enter Email",
        deptMaster: "Department Master",
        deptName: "Dept. Name",
        deptCode: "Dept. Code",
        createdeptmaster: " Create Department Master",
        editdeptmaster: "Edit Department Master",
        enterdeptName: "Enter Department Name",
        enterdeptCode: "Enter Department Code",
        reqdept_name: "Department Name Required",
        desName: "Designation Master",
        createddesigMAster: "Create Designation Master",
        reqdesignname: "Designation Name Required,",
        enterDesName: "Enter Designation Name",
        entershortCode: " Enter Designation Code",
        selectDet: "Select Department",
        reqdept_id: "Select Department Required",
        editdesMaster: "Edit Designation Master",
        AttachImg: "Attach Transaction Receipt",
        SelectDepartment: "Select Department",
        SelectDesignation: "Select Designation",
        FileClass: "File Class",
        classDescription: "Class Description",
        shortName: "Short Name",
        weedingOutAuthority: "Weeding Out Authority",
        CreateclassDescription: "Create Class Description",
        EnterShortName: "Enter Short Name",
        EnterClassDescription: "Enter Class Description",
        EnterWeedingOutAuthority: "Enter Weeding Authority ",
        CreateFileClass: "Create File Class",
        EditFileClass: "Edit File Class",
        FileGroupName: "File Group Name",
        EnterFileGroupName: "Enter File Group Name",
        FileGroup: "File Group",
        FileSubject: "File Subject",
        EnterFileSubjectName: " Enter File Subject Name",
        FileSubjectName: "File Subject Name",
        ShortName: "Short Name",
        FileType: "File Type",
        EnterFileTypeName: "Enter File Type Name",
        FileTypeName: "File Type Name ",
        SelectFileGroup: "Select File Group",
        SelectFileCategory: "Select File Category",
        SelectFileType: "Select File Type",
        SelectFileNo: "Select File Number",
        SelectFileClass: " Select File Class",
        SelectFileSubject: "Select File Subject",
        ReceiptStatus: "Receipt Status",
        RecName: "Receipt Name",
        EnterRecName: "Enter Receipt Name",
        ReceiptType: "Receipt Type",
        ReceiptName: "Receipt Name",
        EnterReceiptName: "Enter Receipt Name",
        RecStatus: "Receipt Status",
        EnterRecStatus: "Enter Receipt Status",
        reqRecStatus: "Require Receipt Status ",
        Location: "Location",
        LocationName: "Location Name",
        EnterLocationName: "Enter Location Name",
        LocationShortName: " Location Short Name",
        EnterLocationShortName: "Enter Location Short Name",
        senderID: "Sender ID",
        receiverID: " Recever ID",
        currentLocation: " Current Location",
        EnterSignatureUpload: "Attach Signature",
        EnterLocationObject: "Enter Location Object",
        EnterAbbreviation: "Enter Abbreviation",
        Abbreviation: "Abbreviation",
        LocationObject: "Location Object",
        reqLocationObject: "Require Location Object ",
        reqFileGroupName: "Require File Group Name",
        reqFileSubjectName: "Require File Subject Name",
        reqFileTypeName: "Require File Type Name",
        reqReceiptName: "Require Receipt Name",
        EnterDocUpload: "Attach Document",
        EnterDocSubType: "Doc Subject Type",
        EnterSubDocAbbreviation: "Doc Subject Abbreviation",
        SelectDoctype: "Select Doc Type",
        SelectFileName: "Select file Name",
        SelectSubject: "Select Subject",
        EnterSubFtype: "subject file type",
        SelectDivision: "Select Division",
        EnterCountryShortName: " Enter Country Short Name",
        EnterStateShortName: "Enter State Short Name",
        EnterdisplayNo: "Enter Display Number",
        SelectDocType: "Select Doc Type",
        enterDesCode: "Enter Designation Code",
        DesignationName: "Designation Name",
        DesignationCode: "Designation Code",
        DocType: "Document Type",
        DocSubType: "Document Sub Type",
        CreateDocType: "Create Doc Type",
        EditDocType: "Edit Doc Type",
        EnterDocType: "Enter Doc Type",
        EntryDate: "Entry Date",
        EnterDocName: "Enter Doc Name",
        DocSubject: "Doc Subject",
        Subject: "Subject",
        DocSubSubject: "Doc Sub Subject",
        SubSubject: "Sub Subject",
        FileNo: "File Number",
        Synopsis: "Synopsis",
        FileDef: "File Definition",
        DocumentEntry: "Document Entry",
        DocumentEntryAdd: "Add Document Entry ",
        reqFileNo: "File No Is Require",
        EnterFileNo: "Enter File Number",
        EnterSynopsis: "Enter Synopsis",
        EnterPartNo: "Enter Part Number",
        EnterPeriodFileUpto: "Enter Period File Upto",
        EnterSubject: "Enter Subject",
        EnterFileDef: "Enter File Definition",
        EnterComplete: "Enter Complete",
        EnterAuthenticatePerson: "Enter Authenticated Person",
        EnterFileDate: "Enter File Date",
        SelectFile: "Select File",
        SelectSubject: "Select Subject",
        SelectDivision: "Select Division",
        EnterPeriodDate: "Enter Period Date",
        AttachedFile: "Attached File",
        EnterFileName: "Enter File Name",
        PeriodDate: "Period Date",
        Keywords: "Keywords",
        FileName: "File Name",
        PdfFile: "PDF File",
        DocumentEntryEdit: "Edit Document Entry ",
        EnterKeyword: "Enter Keyword",
        PdfName: "PDF Name",
        DocFiles: "Document Files",
        SelectDoc: "Select Doc",
        SelectLocation: "Select Location",
        reqPdfName: "PDF Name Is Require",
        CreateDocFiles: "Create Document Files",
        EditDocFiles: "Edit Document Files",
        EnterPdfName: "Enter PDF Name",
        EnterKeywords: "Enter Keywords",
        EnterSubFtype: "Enter Sub File Type",
        EnterPdfDate: "Enter PDF Date",
        DocPages: "Doc Pages",
        Comments: "Comments",
        PhysicalSerialNo: "Physical Serial Number",
        PhysicalIndex: "Physical Index",
        CreateDocPages: "Create Doc Pages",
        EditDocPages: "Edit Doc Pages",
        PageNoFrom: "Page Number From",
        PageNoUpto: "Page Number Upto",
        EnterComments: "Enter Comments",
        EnterPhysicalSerialNo: "Enter Physical Serial Number",
        EnterPhysicalIndex: "Enter Physical Index",
        SelectField: "Select Field",
        DocViewer: "Document Viewer",
        SubFileType: "Sub File Type",
        ViewPdf: "View PDF",
        View: "View",
        NoRecordAvailable: "No Record Available",
        NoPdfAvailable: "No PDF Available",
        AddComment: "Add Comment",
        PageNoFrom: "Page Number From",
        PageNoTo: "Page Number To",
        RelatedOficer: "Related Oficer",
        AddRow: "Add Row",
        Index: "Index!",
        SelectDevision: "Select Devision",
        SelectFileStatus: "Select File Status",
        DocumentIndexing: "Document Indexing",
        Filter: "Filter",
        Print: "Print",
        PeriodFrom: "Period From",
        PeriodTo: "Period To",
        Search: "Search",
        Clear: "Clear",
        ViewIndexPdf: "View Index PDF",
        ViewFullPdf: "View Full PDF",
        FileDefinition: "File Definition",
        SearchKeywords: "Search Keywords",
        DateFrom: "Date From",
        DateTo: "Date To",
        Complete: "Complete",
        SplitPdfToJump: "Split PDF To Jump",
        SplitPage: "Split Page",
        PdfFileName: "PDF File Name",
        PageFrom: "Page From",
        PageTo: "Page To",
        ViewFile: "View File",
        AddPdf: "Add PDF",
        DocUpload: "Document Upload",
        EnterRemark: "Enter Remark",
        EnterValue: "Enter Value",
        FileSaved: "File Saved",
        EnterMainPdf: "Enter Main PDF",
        EnterPdf: "Enter PDF",
        PdfMearge: "PDF Mearge",
        SplitMainFile: "Split Main File",
        ForRename: "For Rename",
        ForShiftCategory: "For Shift Category",
        UpdatePdf: "Update PDF",
        PdfCounter: "PDF Counter",
        EnterFolderPath: "Enter Folder Path",
        Count: "Count",
        EmployeeEntry: "Employee Entry",
        EmployeeName: "Employee Name",
        Login: "Login",
        Password: "Password",
        Edit: "Edit",
        delete: "Delete",
        Export: "Export",
        Release: "Release",
        Post: "Post",
        SelectEmployeeName: "Select Employee Name",
        ParentName: "Parent Name",
        EmployeeMaster: "Employee Master",
        EmpName: "Employee Name",
        EmpCode: "Employee Code",
        EmpStatus: "Employee Status",
        SelectState: "Select State",
        SelectCountry: "Select Country",
        SelectDistrict: "Select District",
        reqEmpName: "Employee name Is Require",
        reqEmpCode: "Employee Code is Require",
        reqFatherName: "Father Name Is Require",
        reqMobNo: "Mobile Number Is Require",
        reqPanNo: "Pan Number Is Require",
        reqJoiningDate: "Joining Date Is Require",
        reqDesignation: "Designation Is Require",
        reqDepartment: "Department Is Require",
        reqPerAddress: "Permanent Address Is Require",
        reqPinCode: "Pin Code Is Require",
        reqAdharNo: "Adhar Number Is Require",
        reqEmail: "Email Is Require",
        reqEmpdob: "Employee DOB Is Required",
        CreateEmployeeReg: "Create Employee Registration",
        EditEmployeeReg: "Edit Employee Registration",
        EnterEmpName: "Enter Employee Name",
        EnterEmpCode: "Enter Employee Code",
        EnterFatherName: "Enter Father Name",
        EnterSpauseName: "Enter Spouse Name",
        EnterMotherName: "Enter Mother Name",
        EnterMobileNumber: "Enter Mobile Number",
        EnterEmail: "Enter Email",
        EnterPanNo: "Enter Pan Number",
        EnterAdharNo: "Enter Adhar Number",
        EnterDOB: "Enter Date Of Birth",
        EnterJoiningDate: "Enter Joining Date",
        EnterRetirementDate: "Enter Retirement Date",
        EnterLocalAddress: "Enter Local Address",
        EnterPerAddress: "Enter Permanent Address",
        EnterPinCode: "Enter Pin Code",
        AttachedImage: "Attached Image",
        DocManagerReport: "Doc Manager Report",
        SelectSubSubject: " Select Sub Subject",
        SubSubjectName: "Sub Subject Name",
        DivisionName: "Division Name",
        Remark: "Remark",
        SessionYear: "Session Year",
        InActive: "InActive",
        Active: "Active",
        TotalDoc: "Total Document",
        TotalType: "Total Type",
        TotalIndexFile: "Total Index File",
        TotalSplitFile: "Total Split File",
        Zone: "Zone",
        LineChart: "Line Chart",
        Department: "Department",
        AcademicDepartment: "Academic Department",
        DocumentManagementSystem: "Document Management System",
        DocMng: "Document Manager",
        PartNo: "Part Number",
        PeriodFileNo: "Period File Number",
        AuthonticatedPerson: "Authonticated Person",
        FileDate: "File Date",
        SubjectId: "Subject ID",
        ToDate: "To Date",
        MergeToIndexFile: "Merge To Index File",
        MergeToOriginalFile: "Merge To Original File",
        DOB: "Date Of Birth",
        Comment: "Comment",
        DesignationMaster: "Designation Master",
        enteritemType: "Enter Item Type",
        enteritemTypecode: "Enter Item Type Code",
        itemType: "Item Type",
        itemTypecode: "Item Type Code",
        ItemType: "Item Type",
        entertaxName: "Enter Tax Name",
        entertaxPercentage: "Enter Tax Percentage",
        entereffectiveDate: "Enter Effective Date",
        taxName: "Tax Name",
        taxPercentage: "Tax Percentage",
        effectiveDate: "Effective Date",
        TaxMaster: "Tax Master",
        unitName: "Unit Name",
        unitShortname: "Unit Short Name",
        UnitMaster: "Unit Master",
        selectUnit: "Select Unit",
        enterunitName: "Enter Unit Name",
        enterunitShortname: "Enter Unit Short Name",
        enteritemName: "Enter Item Name",
        enteritemCode: "Enter Item Code",
        selectitemTypeId: "Select Item Type",
        enterempId: "Enter Employee ID",
        entertaxId: "Enter Tax ID",
        itemCategory: "Enter Item Category",
        enterunitId: "Enter Unit Name",
        entermodelNo: "Enter Model No",
        enterserialNo: "Enter Serial No",
        entervehicleNo: "Enter Vehicle No",
        enterchesisNo: "Enter Chesis No",
        chesisNo: "Model No",
        enterhsnCode: "Enter hsn Code",
        enteritemWeight: "Enter Item Weight",
        enterdepreciationRate: "Enter Depreciation Rate",
        enterpurchaseYear: "Enter Purchase Year",
        itemName: "Item Name",
        itemCode: "Item Code",
        purchaseYear: "Purchase Year",
        modelNo: "ModelNo",
        serialNo: "SerialNo",
        vehicleNo: "VehicleNo",
        hsnCode: "HSN Code",
        itemWeight: "Item Weight",
        ItemMaster: "Item Master",
        Purchaseorder: " Create Purchase Bill",
        EditPurchaseorder: "Edit Purchase Bill",
        entryNo: "EntryNo",
        batchNo: "Batch Number",
        itemId: "ItemId",
        unitID: "UnitId",
        rate: "Rate",
        inQty: "inQty",
        outQty: "outQty",
        voucherId: "VoucherId",
        stockBinId: "StockBinId",
        voucherType: "Voucher Type",
        voucherDate: "Voucher Date",
        expiryDate: "Expiry Date",
        companyId: "CompanyId",
        gstRate: "gstRate",
        cgst: "cgst",
        sgst: "sgst",
        igst: "igst",
        gstid: "gstid",
        cgstid: "cgstid",
        sgstid: "sgstid",
        igstid: "igstid",
        StockLedger: "StockLedger",
        enterentryNo: "Enter Entry No",
        enterbatchNo: "Enter Batch No",
        enteritemId: "Enter ItemId",
        enterunitID: "Enter UnitId",
        enterrate: "Enter Rate",
        enterinQty: "Enter InQty ",
        enteroutQty: "Enter outQty",
        entervoucherId: "Enter VoucherId",
        entervoucherType: "Enter Voucher Type",
        entervoucherDate: "Enter Voucher Date",
        enterexpiryDate: "Enter Expiry Date",
        entergstRate: "Enter GST Rate ",
        entercgst: "Enter CGST",
        entersgst: "Enter SGST",
        enterigst: "Enter IGST",
        entergstid: "Enter gstid",
        entersgstid: "Enter sgstid",
        enterigstid: "Enter igstid",
        itemCategory: "itemCategory",
        itemCategoryAbbre: "ItemCategory short name",
        parentId: "ParentId",
        taxId: "TaxId",
        enteritemCategory: "Enter Item Category",
        enteritemCategoryAbbre: "Enter Item Category short name",
        entertaxId: "Enter TaxId",
        enterparentId: "Enter ParentId",
        ItemCategory: "ItemCategory",
        JurisdictionMaster: "Jurisdiction Master",
        EnterJurisdictionName: "Enter Jurisdiction Name",
        SelectNode: "Select Node",
        NodePermission: "Node Permission",
        SelectUser: "Select User",
        PollMaster: "Pole Master",
        CreatePollMaster: "Create Pole Master",
        poleName: "Pole Name",
        SelectPollType: "Select Poll Type",
        Hight: "Hight",
        wight: "Weight",
        Thickness: "Thickness",
        poleColor: "Pole Color",
        underGroundPoleHight: "Under Ground Pole Hight",
        numOfLightAttach: "Number Of Light Attach",
        currentStatus: "Current Status",
        poleImg: "Pole Image",
        EditPollMaster: "Edit Pole Master",
        PoleType: "Pole Type",
        PoleTypeName: "Pole Type Name",
        //Inventory Module
        indent: "Indent Form",
        CreateIndent: "Create Indent",
        EditIndent: "Edit Indent",
        estimateNo: "Enter Estimate No",
        emp_name: "Select Employee Name",
        indentDate: "Indent Date",
        AutoIndentForm: "Auto Indent Number",
        indentNo: "Indent Number",
        reqBefDate: "Select Request Before Date",
        storeId: "Select Store ",
        patCodeNo: "Enter PatCode Number",
        Vendordetails: "Vendor Details",
        enteritemType: "select Item Type",
        enteritemTypecode: "Enter Item Type Code",
        itemType: "Item Type",
        itemTypecode: "Item Type Code",
        ItemType: "Item Type",
        entertaxName: "Enter Tax Name",
        entertaxPercentage: "Enter Tax Percentage",
        entereffectiveDate: "Enter Effective Date",
        taxName: "Tax Name",
        taxPercentage: "Tax Percentage",
        effectiveDate: "Effective Date",
        TaxMaster: "Tax Master",
        unitName: "Unit Name",
        unitShortname: "Unit Short Name",
        UnitMaster: "Unit Master",
        enterunitName: "Enter Unit Name",
        enterunitShortname: "Enter Unit Short Name",
        enteritemName: "Enter Item Name",
        enteritemCode: "Enter Item Code",
        enteritemTypeId: "Enter Item Type ID",
        enterempId: "Enter Employee ID",
        empid: "Enter Employee ID",
        entertaxId: "Enter Tax ID",
        itemCategory: "Enter Item Category",
        enterunitId: "Enter Unit ID",
        entermodelNo: "Enter Model No",
        enterserialNo: "Enter Serial No",
        entervehicleNo: "Enter Vehicle No",
        enterchesisNo: "Enter Chesis No",
        chesisNo: "Model No",
        enterhsnCode: "Enter hsn Code",
        enteritemWeight: "Enter Item Weight",
        enterdepreciationRate: "Enter Depreciation Rate",
        enterpurchaseYear: "Enter Purchase Year",
        itemName: "Item Name",
        itemCode: "Item Code",
        purchaseYear: "Purchase Year",
        modelNo: "ModelNo",
        serialNo: "SerialNo",
        vehicleNo: "VehicleNo",
        hsnCode: "HSN Code",
        itemWeight: "Item Weight",
        ItemMaster: "Item Master",
        Purchaseorder: " Create Purchase Bill",
        EditPurchaseorder: "Edit Purchase Bill",
        entryNo: "EntryNo",
        batchNo: "Batch Number",
        itemId: "ItemId",
        unitID: "UnitId",
        rate: "Rate",
        inQty: "inQty",
        outQty: "outQty",
        voucherId: "VoucherId",
        stockBinId: "StockBinId",
        voucherType: "Voucher Type",
        voucherDate: "Voucher Date",
        expiryDate: "Expiry Date",
        companyId: "CompanyId",
        gstRate: "gstRate",
        cgst: "cgst",
        sgst: "sgst",
        igst: "igst",
        gstid: "gstid",
        cgstid: "cgstid",
        sgstid: "sgstid",
        igstid: "igstid",
        StockLedger: "Stock Ledger",
        enterentryNo: "Enter Entry No",
        enterbatchNo: "Enter Batch No",
        enteritemId: "Enter ItemId",
        enterunitID: "Enter UnitId",
        enterrate: "Enter Rate",
        enterinQty: "Enter InQty ",
        enteroutQty: "Enter outQty",
        entervoucherId: "Enter VoucherId",
        entervoucherType: "Enter Voucher Type",
        entervoucherDate: "Enter Voucher Date",
        enterexpiryDate: "Enter Expiry Date",
        entergstRate: "Enter GST Rate ",
        entercgst: "Enter CGST",
        entersgst: "Enter SGST",
        enterigst: "Enter IGST",
        entergstid: "Enter gstid",
        entersgstid: "Enter sgstid",
        enterigstid: "Enter igstid",
        itemCategory: "itemCategory",
        itemCategoryAbbre: "ItemCategoryAbbre",
        parentId: "ParentId",
        taxId: "TaxId",
        enteritemCategory: "Enter Item Category",
        enteritemCategoryAbbre: "Enter Item CategoryAbbre",
        entertaxId: "Enter TaxId",
        enterparentId: "Enter ParentId",
        ItemCategory: "ItemCategory",
        JurisdictionMaster: "Jurisdiction Master",
        EnterJurisdictionName: "Enter Jurisdiction Name",
        SelectNode: "Select Node",
        NodePermission: "Node Permission",
        SelectUser: "Select User",
        PollMaster: "Pole Master",
        CreatePollMaster: "Create Pole Master",
        poleName: "Pole Name",
        SelectPollType: "Select Poll Type",
        Hight: "Hight",
        wight: "Weight",
        Thickness: "Thickness",
        poleColor: "Pole Color",
        underGroundPoleHight: "Under Ground Pole Hight",
        numOfLightAttach: "Number Of Light Attach",
        currentStatus: "Current Status",
        poleImg: "Pole Image",
        EditPollMaster: "Edit Pole Master",
        PoleType: "Pole Type",
        PoleTypeName: "Pole Type Name",
        CreateComplaint: "Create Complaint",
        complaintDate: " Complaint Date",
        complaintNo: " Complaint Number",
        itemID: " item name",
        complaintType: "Complaint Type",
        complaintDoc: "ComplaintDoc",
        empId: "Select Employee name",
        complaint: "Complaint",
        complaintDates: "Enter Complaint Date",
        complaintNos: "Complaint Number",
        itemIDs: " Select Item Name",
        complaintTypes: "Enter complaint Type",
        complaintDocs: "Enter complaintDoc",
        empIds: "Select employee name",
        complaints: "Enter complaint",
        status: "status",
        currentReading: "currentReading",
        compAppdt: "compAppdt",
        approveEmp1: "approve Employee1",
        approveEmp2: "approve Employee2",
        approveEmp3: "approve Employee3",
        approveEmp4: "approve Employee4",
        designationName: "Designation",
        departmentName: "Department",
        CreateIndent: "Create Indent",
        EditIndent: "Edit Indent",
        estimateNo: "Enter Estimate No",
        indentDates: "Indent Date",
        ItemName: "Item Name",
        Unit: "Unit",
        Quantity: "Quantity",
        Rate: "Rate",
        Amount: "Amount",
        Tax: "Tax",
        TaxAmount: "Tax Amt.",
        DiscountType: "Dis. Type",
        Discount: "Dis.",
        DiscountAmount: "Dis. Amt.",
        NetAmounts: "Net Amt.",
        document_No: "Enter Document Number",
        p_InvoiceNo: "Enter Purchase Bill Number",
        doc_Date: "Select Document Date",
        p_InvoiceDate: "Enter Purchase Bill Date",
        supplierName: "Select Supplier Name",
        orderNo: "Enter Order Number",
        tax: "Select Tax",
        freight: "Enter frieght",
        amount: "Enter Amount",
        acc_code: "Enter Acc_Code",
        others: "Enter Others",
        remark: "Enter Remark",
        totalAmounts: "Total Amt",
        supplierNames: "Supplier Name",
        document_Nos: "Doc No",
        p_InvoiceNos: "Purchase Bill No",
        doc_Dates: "Doc Date",
        orderNos: "Order No",
        p_InvoiceDates: "Purchase Bill Date",
        freights: "frieght",
        amounts: "Amt",
        ItemStatus: "Item Status",
        StoreMaster: "Store Master",
        EnterStoreName: "Enter StoreName",
        EnterCapacity: "Enter Capacity",
        EnterUnit: "Enter Unit",
        EnterSupervisor: "Enter Supervisor",
        EnterStoreKeeper: "Enter StoreKeeper",
        EnterDescription: "Enter Description",
        EnteruploadDate: "Enter uploadDate",
        Enterstore_type: "Select store type",
        Select_type: "Select type",
        Selectstore_type: "Select store type",
        Indoor: "Indoor",
        Outdoor: "Outdoor",
        storeName: "Store Name",
        capacity: "Capacity",
        unit: "Unit",
        supervisor: "Supervisor",
        storeKeeper: "StoreKeeper",
        description: "Description",
        store_type: "Store type",
        ItemCategory: "Item Category",
        itemCategory: "item Category",
        itemCategoryAbbre: "item Category short name",
        parentId: "parent Category",
        taxId: "tax Id",
        EnteritemCategory: "Enter Item Category ",
        EnteritemCategoryAbbre: "Enter Category short name",
        EnterparentId: "Select Parent Category",
        EntertaxId: "Enter tax Id",
        ItemGroup: "Item Group",
        Entergroup_name: "Enter group name",
        Entergroupshortname: "Enter group short name",
        group_name: "group name",
        groupshortname: "group short name",
        enteritemGroupId: "Enter item GroupId",
        enterwatt: "Enter watt",
        entervolt: "Enter volt",
        enterwire: "Enter wire",
        enterweight: "Enter weight",
        enteritemColor: "Enter item Color",
        enteritemImg: "Enter item Image",
        enterpowerSource: "Enter power Source",
        entergenericName: "Enter generic Name",
        entermanufacture: "Enter manufacture",
        enteritemDimention: "Enter item Dimension",
        enterunderGroundPoleHight: "Enter underGround Pole Height",
        enternum_Of_Light_Attach: "Enter no. Of Light Attach",
        entercurrentStatus: "Enter current Status",
        entercountryOfOrigen: "Enter country Of Origin",
        VendorMaster: "Vendor Master",
        entername: "Enter Name",
        entercode: "Enter Code",
        enterpermanentAddress: "Enter Permanent Address",
        entercontactPerson: "Enter Contact Person",
        entermobileNo: "Enter Mobile Number",
        enterpanNumber: "Enter Pan Number",
        enteraddharNo: "Enter Aadhar Number",
        entergstinNo: "Enter Gstin Number",
        enterstateId: "Enter State Id",
        entercountryId: "Enter Country Id",
        entercityId: "Enter City Id",
        enterpincode: "Enter Pincode",
        name: "Name",
        code: "Code",
        permanentAddress: "Permanent Address",
        contactPerson: "Contact Person",
        mobileNo: "Mobile Number",
        PanNumber: "Pan Number",
        AddharNo: "Aadhar Number",
        GstinNo: "Gstin Number",
        StateId: "State Id",
        CountryId: "Country Id",
        CityId: "City Id",
        Pincode: "Pincode",
        supplierNames: "Supplier Name",
        document_Nos: "Doc No",
        p_InvoiceNos: "Purchase Bill No",
        doc_Dates: "Doc Date",
        orderNos: "Order No",
        p_InvoiceDates: "Purchase Bill Date",
        freights: "frieght",
        amounts: "Amt",
        StoreMaster: "Store Master",
        EnterStoreName: "Enter StoreName",
        EnterCapacity: "Enter Capacity",
        EnterUnit: "Enter Unit",
        EnterSupervisor: "Enter Supervisor",
        EnterStoreKeeper: "Enter StoreKeeper",
        EnterDescription: "Enter Description",
        EnteruploadDate: "Enter uploadDate",
        Enterstore_type: "Enter store type",
        Selectstore_type: "Select store type",
        Indoor: "Indoor",
        Outdoor: "Outdoor",
        storeName: "Store Name",
        capacity: "Capacity",
        unit: "Unit",
        supervisor: "Supervisor",
        storeKeeper: "StoreKeeper",
        description: "Description",
        store_type: "Store type",
        ItemCategory: "Item Category",
        itemCategory: "item Category",
        itemCategoryAbbre: "item CategoryAbbre",
        parentId: "parent Category",
        taxId: "tax Id",
        EnteritemCategory: "Enter Item Category ",
        EnteritemCategoryAbbre: "Enter Category Abbre.",
        EnterparentId: "Select Parent Category",
        EntertaxId: "Enter tax Id",
        ItemGroup: "Item Group",
        Entergroup_name: "Enter group name",
        Entergroupshortname: "Enter group short name",
        group_name: "group name",
        selectGroup: "Select Group",
        groupshortname: "group short name",

        qc: "Quality Check",
        //qcDate: "Quality Date",
        mrnNo: "MRN No",
        totalAmount: "Total Amount",
        createQualityCheck: "Create Quality Check",
        qcNo: "Enter QC No",
        qcDate: "QC Date",
        selectMRN: "Select MRN",
        EditMaterialRecieptNote: "Edit Material Receipt Note",
        bill_ChalanNo: "Bill/Challan No",
        bill_ChalanDate: "Bill/Challan Date",
        shipmentNo: "Shipment Number",
        VendorDetails: "Vendor Details",
        SelectVendor: "Select Vendor",
        vendorGstin: "Vendor GSTIN",
        vendorContactPerson: "Vendor Contact Person",
        vendorAddress: "Vendor Address",
        vendorMobileNo: "Vendor Mobile No",
        OrderNo: "Order No",
        Item: "Item",
        BatchNo: "Batch Number",
        BalQty: "Bal Qty",
        ApproveQty: "Appr Qty",
        ApproveQty1: "Appr Qty",
        Rate: "Rate",
        Amount: "Amount",
        GSTRate: "GST Rate",
        CGST: "CGST",
        SGST: "SGST",
        IGST: "IGST",
        NetAmount: "Net Amount",
        totalCGST: "Total CGST",
        totalSGST: "Total SGST",
        totalIGST: "Total IGST",
        Remark: "Enter Remark",
        totalGrossAmount: "Total Gross Amount",
        totalGrossAmounts: "Tot. Gross Amt.",
        totalGrossAmountReadOnly:
          "Total Gross Amount Read Only can't be edited",
        totalIGSTReadOnly: "Total IGST Read Only can't be edited",
        totalCGSTReadOnly: "Total CGST Read Only can't be edited",
        totalSGSTReadOnly: "Total SGST Read Only can't be edited",
        totalAmountReadOnly: "Total Amount Read Only can't be edited",
        mrnNo: "MRN No",
        mrnDate: "MRN Date",
        createMaterialRecieptNote: "Create Material Receipt Note",
        editMaterialRecieptNote: "Edit Material Receipt Note",
        mrn: "Material Receipt Note",
        SupplierName: "Supplier Name",
        Unit: "Unit",
        AcceptQty: "Acc Qty",
        MrnQty: "MRN Qty",
        RejectQty: "Rej Qty",
        Reason: "Reason",
        createVendor: "Create Vendor",
        editVendor: "Edit Vendor",
        vendorName: "Enter Vendor Name",
        vendorCode: "Enter Vendor Code",
        tanno: "Enter Tan No",
        SelectCity: "Select District",
        gstin: "Enter GSTIN",
        adharNumber: "Enter Aadhar Number",
        contactPerson: "Enter Contact Person",
        permanentAddress: "Enter Permanent Address",
        pincode: "Enter Pincode",
        AttachedSignature: "Attached Signature",
        AttachedPan: "Attached Pan Card",
        AttachedGSTIN: "Attached GSTIN",
        AttachedTan: "Attached Tan",
        AttachedAadhar: "Attached Aadhar",
        vendorMaster: "Vendor Master",
        editVendorMaster: "Edit Vendor Master",
        contactPersons: "Contact Person",
        CreateIndentApproval: "Create Indent Approval",
        enterIndentNo: "Select Indent No.",
        reqBefDate: " Required By Date",
        store: "StoreID",
        selectIndentNo: "Select Indent No",
        emp_name: "Employee Name",
        ApproveAllItems: "Approve All Items",
        ShowExisting: "Show Existing",
        CreateForwardLevel: "Create Forward Level",
        Action: "Action",
        Forward: "Forward",
        Refuse: "Refuse",
        Pass: "Pass",
        CreateIndentStore: "Indent Approve",
        JobWork: "JobWork",
        JobCard: "Create Job Card",
        jobCardNo: "jobCardNo",
        jobCardDate: "jobCardDate",
        complain: "complaint",
        Service: "Service",
        Vendor: "Vendor",
        Qty: "Qty",
        UnitRate: "Unit Rate",
        Reading: "Reading",
        ChallanNo: "ChallanNo",
        createitemMaster: "Create Item Master",
        edititemMaset: "Edit Item Master",
        selectItemCategory: "Select Item Category",
        itemNameRequired: "Item name is required",
        itemNameMin: "Item name must be at least 2 characters",
        itemNameMax: "Item name cannot exceed 200 characters",
        inqty: "Enter In Quantity",
        totalAmountafterTax: "Total Amount after Tax",
        editStockledger: "Edit Stock Ledger",
        selectJobCard: "Select Job Card",
        selectItem: "Select Item",

        JurisdictionMaster: "Jurisdiction Master",
        EnterJurisdictionName: "Enter Jurisdiction Name",
        SelectNode: "Select Node",
        NodePermission: "Node Permission",
        SelectUser: "Select User",
        PollMaster: "Pole Master",
        CreatePollMaster: "Create Pole Master",
        poleName: "Pole Name",
        SelectPollType: "Select Poll Type",
        Hight: "Hight",
        wight: "Weight",
        Thickness: "Thickness",
        poleColor: "Pole Color",
        underGroundPoleHight: "Under Ground Pole Hight",
        numOfLightAttach: "Number Of Light Attach",
        currentStatus: "Current Status",
        poleImg: "Pole Image",
        EditPollMaster: "Edit Pole Master",

        PoleType: "Pole Type",
        PoleTypeName: "Pole Type Name",

        //Inventory Module
        CreateIndent: "Create Indent",
        EditIndent: "Edit Indent",
        estimateNo: "Enter Estimate No",
        emp_name: "Enter Employee Name",
        indentDate: "Select Indent Date",
        SelectZone: "Select Zone",
        PoleInstallationDate: "Pole Installation Date",
        CreatePoleInstallation: "New Pole Installation",
        PoleInstallation: "Pole Installation",
        EditPoleInstallation: "Edit Pole Installation",
        PoleImg: "Pole Image",
        islightinst: "Is Light Install",
        apprdate: "Approved Date",
        depth: "Depth",
        PoleNo: "Pole Number",
        longitute: "Longitude",
        InstallOfLight: "Install Of Light",
        Employee: "Employee",
        ItemName: "Item Name",
        LightInstallation: "Light Installation",
        LightInstallationDate: "Light Installation Date",
        CreateLightInstallation: "New Light Installation",
        EditLightInstallation: "Edit Light Installation",
        lightNo: "Light Number",
        walt: "Watt",

        qc: "Quality Check",
        //qcDate: "Quality Date",
        mrnType: "MRN Type",
        totalAmount: "Total Amount",
        createQualityCheck: "Create Quality Check",
        qcNo: "Enter QC No",
        selectMRN: "Select MRN",
        EditMaterialRecieptNote: "Edit Material Receipt Note",
        bill_ChalanNo: "Bill/Challan No",
        bill_ChalanDate: "Bill/Challan Date",
        shipmentNo: "Shipment Number",
        VendorDetails: "Vendor Details",
        SelectVendor: "Select Vendor",
        vendorGstin: "Vendor GSTIN",
        vendorContactPerson: "Vendor Contact Person",
        vendorAddress: "Vendor Address",
        vendorMobileNo: "Vendor Mobile No",
        OrderNo: "Order No",
        Item: "Item",
        BatchNo: "Batch Number",
        BalQty: "Bal Qty",
        ApproveQty: "Appr Qty",
        ApproveQty1: "Appr Qty",

        Rate: "Rate",
        Amount: "Amount",
        GSTRate: "GST Rate",
        CGST: "CGST",
        SGST: "SGST",
        IGST: "IGST",
        NetAmount: "Net Amount",
        totalCGST: "Total CGST",
        totalSGST: "Total SGST",
        totalIGST: "Total IGST",
        Remark: "Enter Remark",
        totalGrossAmount: "Total Gross Amount",
        totalGrossAmountReadOnly:
          "Total Gross Amount Read Only can't be edited",
        totalIGSTReadOnly: "Total IGST Read Only can't be edited",
        totalCGSTReadOnly: "Total CGST Read Only can't be edited",
        totalSGSTReadOnly: "Total SGST Read Only can't be edited",
        totalAmountReadOnly: "Total Amount Read Only can't be edited",
        mrnNo: "MRN No",
        mrnDate: "MRN Date",
        createMaterialRecieptNote: "Create Material Receipt Note",
        editMaterialRecieptNote: "Edit Material Receipt Note",
        mrn: "Material Receipt Note",
        SupplierName: "Supplier Name",
        Unit: "Unit",
        AcceptQty: "Acc Qty",
        MrnQty: "MRN Qty",
        RejectQty: "Rej Qty",
        Reason: "Reason",
        createVendor: "Create Vendor",
        editVendor: "Edit Vendor",
        vendorName: "Enter Vendor Name",
        vendorCode: "Enter Vendor Code",
        tanno: "Enter Tan No",
        SelectCity: "Select District",
        gstin: "Enter GSTIN",
        adharNumber: "Enter Aadhar Number",
        contactPerson: "Enter Contact Person",
        permanentAddress: "Enter Permanent Address",
        pincode: "Enter Pincode",
        AttachedSignature: "Attached Signature",
        AttachedPan: "Attached Pan Card",
        AttachedGSTIN: "Attached GSTIN",
        AttachedTan: "Attached Tan",
        AttachedAadhar: "Attached Aadhar",
        vendorMaster: "Vendor Master",
        editVendorMaster: "Edit Vendor Master",
        contactPersons: "Contact Person",
        CreateIndentApproval: "Create Indent Approval",
        //enterIndentNo:"EnterIndentNo",
        reqBefDate: " Required By Date",
        store: "StoreID",
        selectIndentNo: "Select Indent No",
        emp_name: "Employee Name",
        ApproveAllItems: "Approve All Items",
        ShowExisting: "Show Existing",
        CreateForwardLevel: "Create Forward Level",
        Action: "Action",
        Forward: "Forward",
        Refuse: "Refuse",
        Pass: "Pass",
        CreateIndentStore: "Indent Approve",
        JobWork: "JobWork",
        JobCard: "Create Job Card",
        jobCardNo: "jobCardNo",
        jobCardDate: "jobCardDate",
        complain: "complaint",
        Service: "Service",
        Vendor: "Vendor",
        Qty: "Qty",
        UnitRate: "Unit Rate",
        Reading: "Reading",
        ChallanNo: "ChallanNo",
        approveEmp1: "Select Approve Employee 1",
        approveEmp2: "Select Approve Employee 2",
        approveEmp3: "Select Approve Employee 3",
        approveEmp4: "Select Approve Employee 4",
        reqitem: "Select Item Required",
        reqEmp: "Select Employee Required",
        reqComNo: "ComplaintNo Required",
        StaffIndent: "Staff Indent",
        createStaffIndent: "Create Staff Indent",
        EditStaffIndent: "Edit Staff Indent",
        StaffItemReturn: "Staff Item Return",
        createStaffItemReturn: "Create Staff Item Return",
        EditStaffItemReturn: "Edit Staff Item Return",
        StaffItemIssue: "Staff Item Issue",
        createStaffItemIssue: "Create Staff Item Issue",
        EditStaffItemIssue: "Edit Staff Item Issue",
        AprQty: "ApproveQty",
        IndentNo: "Indent Number",
        Date: "Date",
        IssueDate: "Issue Date",
        Required: "Required",
        Stock: "Stock",
        Issue: "Issue",
        Employee: "Employee",
        IndentDate: "IndentDate",
        ReturnDate: "ReturnDate",
        Scrabble: "Scrabble",
        Indent: "Indent",
        PendingQty: "PendingQty",
        ReturnQty: "ReturnQty",
        ComplaintTypeMaster: "Complaint Type Master",
        compTypeName: "Complaint Type Name",
        // compType:"Complaint Type",
        AddItem: "AddItem",

        apprImg: "Approvel  Image",

        ComplainDate: "Complaint Date",
        SelectComplain: "Select Complaint",
        Complain: "Complaint",
        AssignComplain: "Complaint Assign",
        InventoryToAsset: "Inventory To Asset",
        Quantity: "Quantity",
        StoreName: "Store Name",
        AreaWard: "Ward/Area",
        EnterZone: "Select Zone",
        EnterWardNumber: "Enter Ward Number",
        EnterAreaName: "Enter Area Name",
        AreaName: "Area Name",
        WardNumber: "Ward Number",
        RouteDetail: "Route Detail",
        EnterRouteName: "Enter Route Name",
        EnterRouteDate: "Enter Route Date",
        EnterRouteDesc: "Enter Route Desc",
        RouteName: "Route Name",
        RouteDesc: "Description",
        RouteDate: "Route Date",
        RosterVisit: "Roster Visit",
        VisitNumber: "Visit No.",
        SelectRoster: "Select Roster Group",
        ItemNumber: "Item No.",
        WarrantyDate: "Warranty",
        Ward: "Ward",
        Roster: "Roster",
        Warranty: "Warranty",
        VisitDate: "Visit Date",
        WardNo: "Ward No.",

        reqEmpName: "Employee Name is required",
        reqEstimateNum: "Estimate Number is required",
        reqDocumentNum: "Document Number required",
        reqOrderNum: "Order Number required",
        reqOrderDate: "Order Date required",
        reqInvDate: "Invoice Date required",
        reqSuppName: "Supplier Name required",
        Purchaseorderdetails: "Purchase Order Details",
        reqPollNum: "Poll Number is required",
        reqItemName: "Item Name is required",
        reqQcDate: "QC date is required",
        reqBillNum: "Bill/Challan number is required",
        reqBillDate: "Bill/Challan date is required",
        Approve: "Approve",
        reqIndentNum: "Indent number is required",
        SelectIndentNo: "Select Indent Number",
        SelectindentDate: "Select Indent Date",
        SelectreqBefDate: "Select Verification Date",
        CreateIndentForwardLevel: "Create Indent Forward Level",
        reqZoneName: "Zone name is required",
        reqdeptName: "Department name is required",
        reqAreaname: "Area name is required",
        reqWardNum: "Ward number is required",
        reqItemType: "Item type is required",
        reqTaxName: "Tax name is required",
        reqTaxPercent: "Tax percentage is required",
        reqUnitName: "Unit name is required",
        reqStoreName: "Store name is required",
        EmpNameRequired: "Employee name required",
        EmpCodeRequired: "Employee code is required",
        MobNoRequired: "Mobile number is required",
        PanNoRequired: "Pan number is required",
        AdharNoRequired: "Aadhar number is required",
        reqBatchnum: "Batch Number is required",
        CreateStockledger: "Create Stock Ledger",
        SelectitemId: "Select Item Name",
        reqQuantity: "Quantity is required",
        reqItemCategory: "Item category is required",
        reqGroupName: "Group name is required",
        reqPollName: "Pole name is required",
        reqPollType: "Pole type is required",
        reqcompTypeName: "Complaint type is required",
        reqAssignDate: "Complain Date is required",
        reqComplain: "Complain is required",
        reqRouteName: "Route name is required",
        reqRouteDate: "Route date is required",
        reqVisitNum: "Visit number is required",
        reqVisitDate: "Visit date is required",
        reqItemStatus: "Item Status is required",
        reqWarranty: "Warranty is required",
        reqRosterGroup: "Roster group is required",
        reqItemNum: "Item Number is required",

        FatherNameRequired: "Father name is required",
        DobRequired: "DOB is required",
        JoiningDateRequired: "Joining date is required",
        DesignationRequired: "Designation is required",
        PermanentAddressRequired: "Permanent Address is required",
        PincodeRequired: "Pincode is required",
        jwchallan: "Job Work Challan",
        reqCountryName: "Country name is required",
        reqStoreId: "Select Store Required",
        OpeningStockOfItems: "Opening Stock Of Items",
        enterunit: "Select Unit",
        enteritem: "Select Item",
        vouchertype: "Voucher Type",
        item: "Item",
        SelectSupplierName: "Select Supplier Name",
        SelectIndent: "Select Indent",
        PurchaseNo: "Purchase No",
        PurchaseInvoice: "Purchase Bill",
        editPurchaseorder: "Edit Purchase Order",
        PurchaseReturn: "Purchase Return",
        PurchaseInvoiceOption: "Select Purchase Bill",
        pR_InvoiceDate: "Purchase Return Order Date",
        pR_InvoiceNo: "Purchase Return Order Number",
        PurchaseReturnorder: "Purchase Return Order",
        EditPurchaseReturnorder: "Edit Purchase Return Order",
        CreateMrnDetails: "Create MRN Details",
        EditMrnDetails: "Edit MRN Details",
        MrnDetails: "MRN Details",
        MrnNo: "MRN No",
        SelectOrderNO: "Select OrderNO",
        GstNoRequired: "GSTIN No Requied",
        StockReport: "Stock Report",
        SelectItem: "Select Item",
        StockSummary: "Stock Summary",
        ComplainApprovalMaster: "Complain Approval Master",
        ComplaintApproval: "Complain Approval",
        InQuantity: "In Quantity",
        UnitName: "Unit Name",
        SelectStore: "Select Store",
        ReturnQuantity: "Return Quantity",
        SelectPurchaseOrder: "Select Purchase Order",

        brandmaster: "Brand master",
        brandname: "Brand Name",

        EditComplaint: "Edit Complaint",
        Map: "Map",
        PurchaseOrder: "Purchase Order",
        PurchaseDate: "Purchase Order Date",
        PurchaseOrderNo: "Purchase Order No",
        CreatePurchaseOrder: "Create Purchase Order",
        AutoPurchaseOrder: "Auto Purchase Order",
        PurchaseOrderDate: "Purchase Order Date",
        EditPurchaseOrder: "Edit Purchase Order",
        lightswitch: "Light Switch On/Off Report",
        poleno: "Enter Pole No",
        show: "Show",
        SelectQC: "Select QC No",
        ApprovedDate: "Approved Date",
        InstallationDate: "Installation Date",
        ComplaintDate: "Complaint Date",
        ComplaintNo: "Complaint No",
        Complaint: "Complaint",
        ComplaintType: "Complaint Type",
        ComplainAssignTo: "Complain Assign To",
        SelectPole: "Select Pole",
        devivename: "Device Name",
        deviceno: "Device No",
        simno: "Sim No",
        simContactNo: "Sim Contact No",
        relayNo: "Relay No",
        deviceInstDate: "Device Installed Date",
        nooflight: "No Of Light",
        deviceMaster: "Device Installation",
        CreateDeviceMaster: "New Device Installation",
        EditDeviceInstall: "Edit Device Installation",
        Institute: "Organization",
        ResidencialAddress: "Residencial Address",
        CollegeCategory: "College Category",
        InstituteName: "Org. Name",
        LetterNo: "Letter Number",
        Priority: "Priority",
        Language: "Language",
        CreateInstitute: "Create Organization",
        EditInstitute: "Edit Organization",
        ShowAcademicSession: "Show Academic Session",
        ShowFinancialYear: "Show Financial Year",
        EditAcademicSession: "Edit Academic Session",
        EditableFinancialYear: "Editable Financial Year",
        DefaultJurisdiction: "Default Jurisdiction",
        OrgType: "Organization Type :",
        Yes: "Yes",
        No: "No",
        School: "School",
        College: "College",
        University: "University",
        Address: "Address",
        District: "District",
        YearOfEstablishment: "Year Of Establishment",
        Category: "Category",
        Principal: "Principal",
        collegeStatus: "college Status",
        ResidencialAddress: "Residential Address",
        MobNo: "Mobile Number",
        OficeNO: "Office Number",
        ResiNO: "Resi Number",
        PinCode: "Pin Code",
        Fax: "Fax",
        Website: "Website",
        DistrictArea: "District Area",
        StatusPg: "Status Pg",
        Registrar: "Registrar",
        NameOfFaculties: "Name Of Faculties",
        NoOfTeachers: "No Of Teachers",
        DateFrom: "Date From",
        AccesedByNaac: "Accesed By Naac",
        SessionYear: "Session Year",
        ReAtendenceDuration: "Re Atendence Duration",
        EnableAutoStuCredentials: "Enable Auto Students Credentials",
        SelectStudentRoles: "Select Student Roles",
        EnableAutoEmpCredentials: "Enable Auto Employee Credentials",
        SelectEmployeeRoles: "Select Employee Roles",
        EnableBiometric: "Enable Biometric",
        EnableDualBiometric: "Enable Dual Biometric",
        MenuType: "Menu Type",
        SelectParentInstitute: "Select Parent Institute",
        MenuOverColor: "Menu Over Color",
        MenuBackColor: "Menu Back Color",
        Attachedlogo: "Attached logo",
        UploadImage: "Upload Image",
        ReportHeaderImg: "Report Header Image",
        ReportFooterImg: "Report Footer Image",
        ReportHeader: "Report Header",
        EnterNoOnly: "Enter Number Only",
        reqYearOfEstablishment: " Year Of Establishment Required",
        reqMobNo: "Mobile Number Is Required",
        reqMinTenDigits: "Minimun 10 Digit Is Required",
        reqNoOfTeachers: "Number Of Teacher Is Required",
        reqSessionYear: "Session Year Is Required",
        reqReAtendenceDuration: "Re Attendence Duration Is Required",
        SelectDevision: "Select Division",
        SelectRoot: "Select Root",
        VendorName: "Vendor Name",
        AddEmailSetting: "Add Email Setting",
        EditEmailSetting: "Edit Email Setting",
        Host: "Host",
        Port: "Port",
        SelectWarranty: "Select Warranty",
        SelectHSN: "Select HSN",
        HsnMaster: "HSN Master",
        hsnName: "HSN Name",
        warrantyName: "Warranty Name",
        WarrantyMaster: "Warranty Master",
        StatusMaster: "Status Master",
        ComplainStatus: "Complain Status",
        Escrap: "Escrap Report",
        EscrapDate: "Escrap Date",
        ExpiryDate: "Expiry Date",
        ComplaintDescription: "Complaint Description",
        OutQuantity: "Out Quantity",
        ComplaintStatus: "Complaint Status",
        SelectEmployee: "Select Employee",
        SelectComplaintNo: "Select Complaint Number",
        PoleInstalledReport: "Pole Installed Report",
        MrnDetailsReport: "MRN Details Report",
        SelectMRN: "Select MRN",
        QualityCheckReport: "Quality Check Report",
        SelectQc: "Select Qc",
        PurchaseBillReport: "Purchase Bill Report",
        DeviceSchedule: "Device Schedule",
        OnTime: "On Date/Time",
        OffTime: "Off Date/Time",
        ComplaintReport: "Complaints Report",
        ComplaintDesc: "Complaint Description",
        OpenHight: "Open Height",
        SelectDeviceNo: "Select Device Number",
        PageSetup: "Page Setup",
        PageName: "Page Name",
        FieldName: "Field Name",
        IsActive: "Is Active",
        SelectComplainNo: "Select Complaint Number",
        Source: "Source",
        TypeOfPole: "Type Of Pole",
        Weight: "Weight",
        TypeOfLight:"Type Of Light",
      },

      content: {},
    },
  },
  hi: {
    translation: {
      label: {},
      error: {},
      message: {},
      text: {
        groupName: "समूह का नाम दर्ज करें",
        wardId: "वार्ड का नाम  चुनें",
        zoneId: "जोन का नाम चुनें",
        groupDate: "समूह की तिथि चुनें",
        CreateRosterGroup: "रोस्टर समूह बनाएं",
        EditRosterGroup: "रोस्टर समूह संपादित करें",
        RosterGroup: "रोस्टर समूह",
        selectemployee: "कर्मचारी चुनें",
        groupName1: "समूह का नाम",
        wardId1: "वार्ड आईडी",
        groupDate1: "समूह की तिथि",

        zoneMaster: "ज़ोन मास्टर",
        add: "जोड़ें",
        print: "प्रिंट",
        Active: "सक्रिय",
        InActive: "निष्क्रिय",
        Action: "क्रिया",
        SrNo: "क्रम संख्या",
        zoneName: "जोन का नाम",
        zoneCode: "ज़ोन कोड",
        Status: "स्थिति",
        search: "खोजें",
        save: "सहेजें",
        reset: "रीसेट करें",
        createZoneMaster: "ज़ोन मास्टर बनाएं",
        editZoneMaster: "ज़ोन मास्टर संपादित करें",
        enterZoneName: "ज़ोन का नाम ",
        enterZoneCode: "ज़ोन का कोड ",
        req: "ज़ोन का नाम आवश्यक है",
        update: "अपडेट",
        wardMaster: "वार्ड मास्टर",
        wardName: "वार्ड का नाम",
        wardCode: "वार्ड कोड",
        createWardMaster: "वार्ड मास्टर बनाएं",
        editWardMaster: "वार्ड मास्टर संपादित करें",
        enterWardName: "वार्ड का नाम ",
        enterWardCode: "वार्ड का कोड ",
        req1: "वार्ड का नाम आवश्यक है",
        SelectZoneName: "जोन का नाम चुनें",
        reqSelectZoneName: "आवश्यक जोन नाम का चयन करें",
        CategoryMaster: "श्रेणी मास्टर",
        CategoryName: "श्रेणी नाम",
        EnterCategoryName: "श्रेणी का नाम दर्ज करें",
        CreateCategoryMaster: "श्रेणी मास्टर बनाएं",
        reqCategory: "आवश्यक श्रेणी नाम दर्ज करें",
        EditCategoryMaster: "श्रेणी मास्टर संपादित करें",
        SubCategoryMaster: "उप श्रेणी मास्टर",
        SubCategoryName: "उप श्रेणी का नाम",
        RemarkName: "टिप्पणी",
        CreateSubCategoryMaster: "उपश्रेणी मास्टर बनाएँ",
        EnterSubCategoryName: "उप श्रेणी का नाम दर्ज करें",
        EnterCategoryRemark: "श्रेणी टिप्पणी दर्ज करें",
        reqSelectCategory: "*कृपया श्रेणी चुनें",
        reqEnterSubCategory: "उप श्रेणी नाम दर्ज करना आवश्यक होना चाहिए",
        SelectCategory: "श्रेणी चुनना",
        EditSubCategoryMaster: "उपश्रेणी मास्टर संपादित करें",

        FromDate: "तारीख से",
        Todate: "तारीख तक",

        Description: "विवरण",
        MaxLength: "लंबाई",
        MaxWidth: "चौड़ाई",
        MaxHeight: "ऊँचाई",
        AreaSquareMeter: "क्षेत्रफल वर्ग मीटर",
        ratePerSqMtr: "दर प्रति वर्गमीटर",
        Amount: "मात्रा",
        Premium: "अधिमूल्य",

        MenuMaster: " मेनू मास्टर",
        ParentName: "अभिभावक का नाम",
        MenuName: "मेनू नाम",
        PageURL: "पेज यूआरएल",
        Icon: "आइकन",
        CreateMenuMaster: "मेनू मास्टर बनाएं",
        EnterMenuName: "मेनू नाम दर्ज करें",
        EnterPageURL: "पेज यूआरएल दर्ज करें",
        EnterIcon: "चिह्न दर्ज करें",
        selectParentMenuName: "पेरेंट मेनू नाम चुनें",
        reqMenuName: "मेनू नाम आवश्यक है",
        EditMenuMaster: "मेनू मास्टर संपादित करें",
        RoleMaster: " रोल मास्टर",
        RoleName: "भूमिका का नाम",
        UserPermissionMaster: "उपयोगकर्ता अनुमति मास्टर",
        UserName: "उपयोगकर्ता नाम",
        CountryMaster: "देश मास्टर",
        CountryName: "देश  का नाम",
        CountryCode: "देश कोड",
        Nationality: "राष्ट्रीयता",
        CreateCountryName: "देश का नाम बनाएं",
        EnterCountryName: "देश का नाम दर्ज करें",
        EnterCountryCode: "देश कोड दर्ज करें",
        EnterNationality: "राष्ट्रीयता दर्ज करें",
        EditCountryMaster: "देश मास्टर संपादित करें",
        StateMaster: "राज्य मास्टर",
        StateName: "राज्य का नाम",
        StateCode: "राज्य कोड",
        CreateStateMaster: "राज्य मास्टर बनाएं",
        EnterStateName: "राज्य का नाम दर्ज करें",
        EnterStateCode: "राज्य कोड दर्ज करें",
        SelectCountryName: "देश का नाम चुनें",
        EditStateMaster: "राज्य मास्टर संपादित करें",
        DistrictMaster: "ज़िला मास्टर",
        DistrictName: "ज़िला का नाम",
        DistrictCode: "ज़िला कोड",
        CreateDistrictMaster: "ज़िला का नाम दर्ज करें",
        EnterDistrictName: "ज़िला का नाम दर्ज करें",
        EnterDistrictCode: "ज़िला कोड दर्ज करें",
        SelectStateName: "राज्य  का नाम चुनें",
        EditDistrictMaster: "ज़िला  मास्टर संपादित करें",
        GenderMaster: "लिंग मास्टर",
        GenderName: "लिंग का नाम",
        GenderCode: "लिंग कोड",
        CreateGenderMaster: "लिंग का नाम दर्ज करें",
        reqGenderName: "लिंग नाम आवश्यक है",
        EnterGenderName: "लिंग का नाम दर्ज करें",
        EnterGenderCode: "लिंग कोड दर्ज करें",
        SelectGenderName: "लिंग का नाम चुनें",
        EditGenderMaster: "लिंग  मास्टर संपादित करें",

        ItemStatus: "आइटम स्थिति",
        Total: "कुल",
        RegNo: " संख्या",
        NameOfPlace: "उप विज्ञापन के प्रकार का नाम",
        Size: "आकार",
        Sqmtr: "वर्ग मीटर",
        Rate: "दर",
        NetAmount: "शुद्ध राशि",
        PaymentMode: "भुगतान का प्रकार",
        Deposit: "जमा",
        Remaining: "शेष",
        Date: "तारीख",
        CreateDirectApplyforAdvertisement: "विज्ञापन के लिए सीधा आवेदन बनाएं",
        UserManegment: "प्रयोक्ता प्रबंधन",
        FirstName: "पहला नाम",
        LoginName: "लॉगिन नाम",
        mobileNo: "मोबाइल नंबर",
        Email: "ईमेल",
        DateOfBirth: "जन्म की तारीख",
        Role: "भूमिका",
        SelectGender: "लिंग चुनें",
        SelectRole: "भूमिका चुनें",
        SelectUserType: "उपयोगकर्ता प्रकार चुनें",
        CreateUserManegment: "उपयोगकर्ता प्रबंधन बनाएं",
        reqFirstName: "पहला नाम आवश्यक है",
        reqMiddleName: "मध्य नाम आवश्यक है",
        reqLastName: "अंतिम नाम आवश्यक है",
        reqloginID: "लॉगिन नाम आवश्यक है",
        reqPassword: "पासवर्ड की आवश्यकता है",
        reqMobileNumber: "मोबाइल नंबर आवश्यक है",
        reqEmailID: "ईमेल आईडी आवश्यक है",
        reqDateofBirth: "जन्म तिथि आवश्यक है",
        reqGender: "लिंग आवश्यक है",
        reqUserType: "उपयोगकर्ता प्रकार आवश्यक है",
        reqRole: "भूमिका आवश्यक है",
        EnterFirstName: "प्रथम नाम दर्ज करें",
        EnterMiddleName: "मध्य नाम दर्ज करें",
        EnterLastName: "अंतिम नाम दर्ज करो",
        EnterLoginName: "लॉगिन नाम दर्ज करें",
        EnterPassword: "पास वर्ड दर्ज करें",
        EnterUserCode: "उपयोगकर्ता कोड दर्ज करें",
        EntermobileNo: "मोबाइल नंबर दर्ज करें",
        EnterEmailId: "ईमेल-आईडी दर्ज करें",
        EnterDateOfBirth: "जन्म तारीख दर्ज करें",
        EditUserManegment: "उपयोगकर्ता प्रबंधन संपादित करें",
        UserTypeMaster: "उपयोगकर्ता प्रकार मास्टर",
        EnterUserType: "उपयोगकर्ता प्रकार दर्ज करें",
        UserType: "उपयोगकर्ता का प्रकार",
        InvalidUserType: "अमान्य उपयोक्ता प्रकार",
        SelectWard: "वार्ड का चयन करें",
        reqAreaName: "विज्ञापन क्षेत्र आवश्यक है",
        reqNoOfSites: "साइटों की संख्या आवश्यक है",
        reqImg: "विज्ञापन छवि आवश्यक है",
        reqAdvertisementTypeID: "आवश्यक विज्ञापन प्रकार का चयन करें",
        reqMaxLength: "अधिकतम लंबाई आवश्यक है",
        reqMaxWidth: "अधिकतम चौड़ाई आवश्यक है",
        reqMaxHeight: "अधिकतम ऊंचाई आवश्यक है",
        reqRatePerSqMtr: "प्रति वर्ग मीटर आवश्यक है",
        reqPremium: "प्रीमियम राशि आवश्यक है",
        enterRoleName: "भूमिका का नाम दर्ज करें",
        reqEnterNotice: "सूचना  दर्ज करना आवश्यक है",
        reqEnterNoticeLink: "सूचना  दर्ज करें लिंक आवश्यक है",
        reqEnterDescription: "विवरण दर्ज करना आवश्यक है",
        rowsperpage: "प्रति पृष्ठ पंक्तियाँ:",
        reqcountryName: "देश का नाम आवश्यक है",
        reqRoleName: "भूमिका का नाम आवश्यक है",
        reqstateName: "राज्य का नाम आवश्यक है",
        reqdistrictName: "ज़िला का नाम आवश्यक है",
        RegisterAgency: "रजिस्टर एजेंसी / विक्रेता",
        RenewRegisterAgency: "नवीनीकरण रजिस्टर एजेंसी/विक्रेता",
        ApplyDate: "आवेदन की तिथि",
        NameOfAgency: "एजेंसी का नाम",
        ContactNo: "संपर्क नंबर",
        Address: "पता",
        PANNo: "पैन नंबर",
        AadhaarNo: "आधार नंबर",
        GSTNo: "जीएसटी नंबर",
        ApplicationFee: "आवेदन शुल्क",
        SelectCompanyCategory: "कंपनी श्रेणी चुनें",
        reqAadharNumber: "आधार नंबर आवश्यक है",
        reqBalanceSheet: "बैलेंस शीट आवश्यक है ",
        reqAddress: "पता आवश्यक है",
        reqState: "राज्य आवश्यक है",
        reqEmail: "ईमेल आवश्यक है",
        reqDistrict: "जिला आवश्यक है",
        reqCompanyCategory: "कंपनी श्रेणी आवश्यक है",
        reqPaymentMode: "भुगतान मोड आवश्यक है",
        reqTransactionNumber: "लेनदेन संख्या आवश्यक है",
        DateOfApply: "आवेदन करने की तिथि",
        EnterRegistrationNo: "पंजीकरण संख्या दर्ज करें",
        EnterName: "नाम दर्ज करें",
        EnterContactNo: "संपर्क नंबर दर्ज करें",
        EnterEmailID: "ईमेल आईडी दर्ज करें",
        EnterPANNo: "पैन नंबर दर्ज करें",
        EnterAadharNo: "आधार नंबर दर्ज करें",
        EnterAddress: "पता दर्ज करें",
        EnterApplicationFees: "आवेदन शुल्क दर्ज करें",
        EnterRegistrationFees: "पंजीकरण शुल्क दर्ज करें",
        reqEnterRegistrationFees: "पंजीकरण शुल्क आवश्यक",
        EnterAgencyName: "एजेंसी का नाम दर्ज करें",
        EnterDINNumber: "डी. आई. एन. संख्या दर्ज करें",
        DINNumber: "डी. आई. एन. नंबर",
        EmailID: "ईमेल आईडी",
        SangamArticle: "कंपनी के समय ज्ञापन तथा संगठन अनुछेद",
        AuthorityExpAdvert:
          "पिछले 3 वर्षों के विज्ञापन व्यवसाय में अभिकरण/फॉर्म का अनुभव",
        Yes: "हाँ",
        No: "नहीं",
        Preview: "पूर्व दर्शन",
        Attach: "संलग्न करना:",
        AttachAadhaarDocument: "आधार दस्तावेज़ संलग्न करें",
        UploadPANDocument: "पैन दस्तावेज़ अपलोड करें",
        OtherDocument: "अन्य दस्तावेज़",
        CreateAgency: "एजेंसी/विक्रेता बनाएं",
        RenewCreateAgency: "नवीनीकरण एजेंसी/विक्रेता",
        EditRenewAgecy: "पंजीकरण एजेंसी/विक्रेता संपादित करें",
        Back: "पीछे",
        Submit: "जमा करना",
        Next: "अगला",
        BasicDetails: "बुनियादी विवरण",
        AgencyDetails: "एजेंसी विवरण",
        TermsAndConditions: "नियम और शर्तें",
        DocUpload: "दस्तावेज़ अपलोड करें",
        EditAgency: "संपादन एजेंसी/विक्रेता",
        DefaultFinancialYear: "डिफ़ॉल्ट वित्तीय वर्ष",
        DayWise: "दिन के अनुसार",
        MonthWise: "माह के अनुसार",
        YearWise: "वर्ष के अनुसार",
        rate: "दर",
        IsRateFixed: "दर तय है",
        EnterRateType: "दर प्रकार दर्ज करें",
        RateType: "दर प्रकार",
        reqName: "नाम आवश्यक है",
        reqAadhaar: "आधार नंबर आवश्यक है",
        reqAadhaarexactly: "आधार नंबर बिल्कुल 12 अंकों का होना चाहिए",
        reqMobile: "मोबाइल नंबर आवश्यक है",
        reqRegistrationPayment: "पंजीकरण भुगतान मोड आवश्यक है",
        reqPanNumber: "पैन नंबर आवश्यक है",
        reqGSTINnumber: "जीएसटीआईएन नंबर आवश्यक है",
        reqApplyDate: "आवेदन तिथि आवश्यक है",
        reqAlert:
          "कृपया तालिका में जोड़ने से पहले सभी आवश्यक फ़ील्ड (एजेंसी का नाम, डीआईएन नंबर, ईमेल आईडी और मोबाइल नंबर) भरें।",
        validMobile: "वैध-मोबाइल है",
        InvalidMobile: "अमान्य मोबाइल नंबर फॉर्मेट है",
        validEmail: "वैध-ईमेल है",
        InvalidEmail: "अमान्य ईमेल प्रारूप है",
        Name: "नाम",
        reqFirst: "पहला नाम आवश्यक है",
        reqLast: "अंतिम नाम आवश्यक है",
        reqLogin: "लॉगिन आईडी आवश्यक है",
        reqDate: "जन्म तिथि आवश्यक है",
        reqUser: "उपयोगकर्ता प्रकार आवश्यक है",
        deptMaster: "विभाग मास्टर",
        deptName: "विभाग का नाम",
        deptCode: "विभाग कोड",
        createdeptmaster: "विभाग मास्टर बनाएँ",
        editdeptmaster: "विभाग मास्टर संपादित करें",
        enterdeptName: "विभाग का नाम दर्ज करें",
        enterdeptCode: "विभाग कोड दर्ज करें",
        reqdept_name: "विभाग का नाम आवश्यक",
        desName: "पदनाम मास्टर",
        createddesigMAster: "पदनाम बनाएं मास्टर",
        reqdesignname: "पदनाम नाम आवश्यक है",
        enterDesName: "पदनाम नाम दर्ज करें",
        entershortCode: "पदनाम कोड दर्ज करें",
        selectDet: "विभाग का चयन करें",
        reqdept_id: "आवश्यक विभाग का चयन करें",
        editdesMaster: "पदनाम संपादित करें मास्टर",
        AttachImg: "लेनदेन रसीद संलग्न करें",
        SelectDepartment: "विभाग का चयन करें",
        SelectDesignation: "पदनाम का चयन करें",
        CreatePetitionerPersonalInformation:
          "याचिकाकर्ता की व्यक्तिगत जानकारी बनाएँ",
        EnterCouncelForRespondent: "प्रतिवादी के लिए परामर्श दर्ज करें",
        EnterRespondentContact: "प्रतिवादी संपर्क दर्ज करें",
        EnterRespondentEmail: "प्रतिवादी ईमेल दर्ज करें",
        SelectCaseNo: "केस नंबर चुनें",
        SelectCourtName: "न्यायालय का नाम चुनें",
        SelectCourtType: "न्यायालय प्रकार का चयन करें",
        EnterRespodingCounselName:
          "प्रत्युत्तर देने वाले वकील का नाम दर्ज करें",
        BaseYear: "आधार वर्ष",
        baseYearName: "आधार वर्ष का नाम",
        DefaultbaseYear: "डिफ़ॉल्ट आधार वर्ष",
        ReqEnterbaseYearName: "आवश्यक आधार वर्ष दर्ज करें",
        CreateBaseYearMaster: "आधार वर्ष मास्टर बनाएं ",
        EditBaseYearMaster: "आधार वर्ष मास्टर संपादित करें",
        SelectBaseYear: "आधार वर्ष चुनें",
        effectiveDate: "प्रभावी तिथि",
        EntryDate: "प्रवेश तिथि",
        SqFt: "वर्ग फुट",
        ReqDate: "दिनांक आवश्यक है",
        ReqFree: "निःशुल्क आवश्यक है",
        ReqRate: "दर आवश्यक है",
        TransactionImage: "रसीद संलग्न करें",
        reqRateType: "दर प्रकार आवश्यक है",
        FileClass: "फ़ाइल वर्ग",
        classDescription: "वर्ग विवरण",
        shortName: "संक्षिप्त नाम",
        weedingOutAuthority: "प्राधिकरण को हटाना",
        CreateclassDescription: "कक्षा विवरण बनाएँ ",
        EnterShortName: "संक्षिप्त नाम दर्ज करें",
        EnterClassDescription: "कक्षा विवरण दर्ज करें",
        EnterWeedingOutAuthority: "प्राधिकरण को बाहर निकालने में प्रवेश करें",
        CreateFileClass: "फ़ाइल वर्ग बनाएँ",
        EditFileClass: "फ़ाइल वर्ग संपादित करें",
        FileGroupName: "फ़ाइल समूह का नाम",
        EnterFileGroupName: "फ़ाइल समूह का नाम दर्ज करें",
        FileGroup: "फ़ाइल समूह",
        FileSubject: "फ़ाइल विषय",
        EnterFileSubjectName: "फ़ाइल विषय नाम दर्ज करें ",
        FileSubjectName: "फ़ाइल का विषय नाम",
        ShortName: "संक्षिप्त नाम",
        FileType: "फ़ाइल प्रकार",
        EnterFileTypeName: "फ़ाइल प्रकार का नाम दर्ज करें",
        FileTypeName: "फ़ाइल प्रकार का नाम",
        SelectFileGroup: "फ़ाइल समूह का चयन करें",
        SelectFileCategory: "फ़ाइल श्रेणी का चयन करें",
        SelectFileType: "फ़ाइल प्रकार का चयन करें",
        SelectFileNo: "फ़ाइल संख्या का चयन करें",
        SelectFileClass: "फ़ाइल वर्ग का चयन करें",
        SelectFileSubject: "फ़ाइल विषय का चयन करें",
        ReceiptStatus: "रसीद की स्थिति",
        RecName: "रसीद का नाम",
        EnterRecName: "रसीद का नाम दर्ज करें",
        ReceiptType: "रसीद का प्रकार",
        ReceiptName: "रसीद का नाम",
        EnterReceiptName: "रसीद का नाम दर्ज करें",
        RecStatus: " रसीद की स्थिति",
        EnterRecStatus: "रसीद की स्थिति दर्ज करें",
        reqRecStatus: "रसीद की स्थिति आवश्यक है ",
        Location: "स्थान",
        LocationName: "स्थान का नाम",
        EnterLocationName: "स्थान का नाम दर्ज करें",
        LocationShortName: " स्थान संक्षिप्त नाम",
        EnterLocationShortName: "स्थान संक्षिप्त नाम दर्ज करें",

        JurisdictionMaster: "क्षेत्राधिकार मास्टर",
        EnterJurisdictionName: "क्षेत्राधिकार का नाम दर्ज करें",
        SelectNode: "नोड का चयन करें",
        NodePermission: "नोड अनुमति",
        SelectUser: "उपयोगकर्ता का चयन करें",
        PollMaster: "पोल मास्टर",
        CreatePollMaster: "पोल मास्टर बनाएं",
        poleName: "ध्रुव नाम",
        SelectPollType: "पोल प्रकार चुनें",
        Hight: "ऊंचाई",
        wight: "वज़न",
        Thickness: "मोटाई",
        poleColor: "ध्रुव रंग",
        underGroundPoleHight: "जमीन के नीचे पोल की ऊंचाई",
        numOfLightAttach: "लाइट संलग्न की संख्या",
        currentStatus: "वर्तमान स्थिति",
        poleImg: "ध्रुव छवि",
        EditPollMaster: "पोल मास्टर संपादित करें",
        PoleType: "पोल प्रकार",
        PoleTypeName: "पोल प्रकार का नाम",
        //Inventory Module
        CreateIndent: "इंडेंट बनाएं",
        EditIndent: "इंडेंट संपादित करें",
        estimateNo: "अनुमान संख्या दर्ज करें",
        emp_name: "कर्मचारी का नाम दर्ज करें",
        indentDate: "इंडेंट दिनांक चुनें",
        SelectZone: "जोन चुनें",
        PoleInstallationDate: "पोल स्थापना तिथि",
        CreatePoleInstallation: "पोल इंस्टालेशन बनाएं",
        PoleInstallation: "पोल स्थापना",
        EditPoleInstallation: "पोल स्थापना संपादित करें",
        PoleImg: "ध्रुव छवि",
        islightinst: "लाइट इंस्टाल है",
        apprdate: "स्वीकृत तिथि",
        depth: "गहराई",
        PoleNo: "पोल संख्या",
        longitute: "देशान्तर",
        InstallOfLight: "प्रकाश की स्थापना",
        Employee: "कर्मचारी",
        ItemName: "आइटम नाम",
        LightInstallation: "प्रकाश स्थापना",
        LightInstallationDate: "लाइट स्थापना तिथि",
        CreateLightInstallation: "लाइट इंस्टालेशन बनाएं",
        EditLightInstallation: "प्रकाश स्थापना संपादित करें",
        lightNo: "प्रकाश संख्या",
        walt: "वाट",

        receiverID: "रिसीवर आईडी",
        currentLocation: "वर्तमान स्थान",
        EnterSignatureUpload: "हस्ताक्षर संलग्न करें",
        EnterLocationObject: "स्थान ऑब्जेक्ट दर्ज करें",
        EnterAbbreviation: "संक्षिप्त नाम दर्ज करें",
        Abbreviation: "लघु रूप",
        LocationObject: "स्थान वस्तु",
        reqLocationObject: "स्थान ऑब्जेक्ट की आवश्यकता है ",
        reqFileGroupName: "फ़ाइल समूह नाम की आवश्यकता है",
        reqFileSubjectName: "फ़ाइल विषय नाम की आवश्यकता है",
        reqFileTypeName: "फ़ाइल प्रकार नाम आवश्यक है",
        reqReceiptName: "रसीद नाम की आवश्यकता है",
        EnterDocUpload: "दस्तावेज़ संलग्न करें",
        EnterDocSubType: "दस्तावेज़ विषय प्रकार",
        EnterSubDocAbbreviation: "दस्तावेज़ विषय संक्षिप्त नाम",
        SelectDoctype: "दस्तावेज़ प्रकार चुनें",
        SelectFileName: "फ़ाइल नाम चुनें",
        SelectSubject: "विषय चुनें",
        SelectDivision: "प्रभाग का चयन करें",
        EnterCountryShortName: "देश का संक्षिप्त नाम दर्ज करें",
        EnterStateShortName: "राज्य का संक्षिप्त नाम दर्ज करें",
        EnterdisplayNo: "डिस्प्ले नंबर दर्ज करें",
        SelectDocType: "दस्तावेज़ प्रकार का चयन करें",
        enterDesCode: "पदनाम कोड दर्ज करें",
        DesignationName: "पदनाम का नाम",
        DesignationCode: "पदनाम कोड",
        DocType: "दस्तावेज़ का प्रकार",
        DocSubType: "दस्तावेज़ उप प्रकार",
        CreateDocType: "दस्तावेज़ प्रकार बनाएँ",
        EditDocType: "दस्तावेज़ प्रकार संपादित करें",
        EnterDocType: "दस्तावेज़ प्रकार दर्ज करें",
        EntryDate: "प्रवेश की तारीख",
        EnterDocName: "दस्तावेज़ का नाम दर्ज करें",
        DocSubject: "दस्तावेज़ विषय",
        Subject: "विषय",
        DocSubSubject: "दस्तावेज़ उप विषय",
        SubSubject: "उप विषय",
        FileNo: "फ़ाइल संख्या",
        Synopsis: "रूपरेखा",
        FileDef: "फ़ाइल परिभाषा",
        DocumentEntry: "दस्तावेज़ प्रविष्टि",
        DocumentEntryAdd: "दस्तावेज़ प्रविष्टि जोड़ें",
        reqFileNo: "फ़ाइल नंबर की आवश्यकता है",
        EnterFileNo: "फ़ाइल संख्या दर्ज करें",
        EnterSynopsis: "सारांश दर्ज करें",
        EnterPartNo: "भाग संख्या दर्ज करें",
        EnterPeriodFileUpto: "तक पीरियड फाइल दर्ज करें",
        EnterSubject: "विषय दर्ज करें",
        EnterFileDef: " फ़ाइल परिभाषा दर्ज करें",
        EnterComplete: "पूर्ण दर्ज करें",
        EnterAuthenticatePerson: "प्रमाणित व्यक्ति दर्ज करें",
        EnterFileDate: "फ़ाइल दिनांक दर्ज करें",
        SelectFile: "फ़ाइल का चयन करें",
        SelectSubject: "विषय का चयन करें",
        SelectDivision: "डिवीजन का चयन करें",
        EnterPeriodDate: "अवधि तिथि दर्ज करें",
        AttachedFile: "अनुलग्न फ़ाइल",
        EnterFileName: "फ़ाइल नाम दर्ज करें",
        PeriodDate: "अवधि की तारीख",
        Keywords: "कीवर्ड",
        FileName: "फ़ाइल का नाम",
        PdfFile: "पीडीएफ",
        DocumentEntryEdit: "दस्तावेज़ प्रविष्टि संपादित करें",
        EnterKeyword: "कीवर्ड दर्ज करें",
        PdfName: "पीडीएफ नाम",
        DocFiles: "दस्तावेज़ फ़ाइलें",
        SelectDoc: "दस्तावेज़ का चयन करें",
        SelectLocation: "स्थान का चयन करें",
        reqPdfName: "पीडीएफ नाम की आवश्यकता है",
        CreateDocFiles: "दस्तावेज़ फ़ाइलें बनाएँ",
        EditDocFiles: "दस्तावेज़ फ़ाइलें संपादित करें",
        EnterPdfName: "पीडीएफ नाम दर्ज करें",
        EnterKeywords: "कीवर्ड दर्ज करें",
        EnterSubFtype: "उप फ़ाइल प्रकार दर्ज करें",
        EnterPdfDate: "पीडीएफ तिथि दर्ज करें",
        DocPages: "दस्तावेज़ पृष्ठ",
        Comments: "टिप्पणियाँ",
        PhysicalSerialNo: "भौतिक क्रम संख्या",
        PhysicalIndex: "भौतिक सूचकांक",
        CreateDocPages: "दस्तावेज़ पेज बनाएं",
        EditDocPages: "दस्तावेज़ पृष्ठ संपादित करें",
        PageNoFrom: "पृष्ठ संख्या से",
        PageNoUpto: "पृष्ठ क्रमांक तक",
        EnterComments: "टिप्पणियाँ दर्ज करें",
        EnterPhysicalSerialNo: "भौतिक सीरियल नंबर दर्ज करें",
        EnterPhysicalIndex: "भौतिक अनुक्रमणिका दर्ज करें",
        SelectField: "फ़ील्ड का चयन करें",
        DocViewer: "दस्तावेज़ व्यूअर",
        SubFileType: "उप फ़ाइल प्रकार",
        ViewPdf: "पीडीएफ देखें",
        View: "देखना",
        NoRecordAvailable: "कोई रिकॉर्ड उपलब्ध नहीं है",
        NoPdfAvailable: "कोई पीडीएफ उपलब्ध नहीं है",
        AddComment: "टिप्पणी जोडा",
        PageNoFrom: "पृष्ठ संख्या से",
        PageNoTo: "पृष्ठ संख्या को",
        RelatedOficer: "संबंधित अधिकारी",
        AddRow: "पंक्ति जोड़ें",
        Index: "सूचकांक!",
        SelectDevision: "प्रभाग का चयन करें",
        SelectFileStatus: "फ़ाइल स्थिति का चयन करें",
        DocumentIndexing: "दस्तावेज़ अनुक्रमण",
        Filter: "फ़िल्टर ",
        Print: "प्रिंट",
        PeriodFrom: "से अवधि",
        PeriodTo: "अवधि से",
        Search: "ढूँढ",
        Clear: "स्पष्ट",
        ViewIndexPdf: "इंडेक्स पीडीएफ देखें",
        ViewFullPdf: "पूरा पीडीएफ देखें",
        FileDefinition: "फ़ाइल परिभाषा",
        SearchKeywords: "खोज कीवर्ड",
        DateFrom: "तारीख से",
        DateTo: "करने के लिए तारीख",
        Complete: "पूरा",
        SplitPdfToJump: "जम्प के लिए पीडीएफ विभाजित करें",
        SplitPage: "विभाजित पृष्ठ",
        PdfFileName: "पीडीएफ फाइल का नाम",
        PageFrom: "पृष्ठ से",
        PageTo: "पृष्ठ तक",
        ViewFile: "फ़ाइल देखें",
        AddPdf: "पीडीएफ जोड़ें",
        DocUpload: "दस्तावेज़ अपलोड",
        EnterRemark: "टिप्पणी दर्ज करें",
        EnterValue: "मान दर्ज करें",
        FileSaved: "फ़ाइल सहेजी गई",
        EnterMainPdf: "मुख्य पीडीएफ दर्ज करें",
        EnterPdf: "पीडीएफ दर्ज करें",
        PdfMearge: "पीडीएफ मर्ज",
        SplitMainFile: "मुख्य फ़ाइल विभाजित करें",
        ForRename: "नाम बदलने के लिए",
        ForShiftCategory: "शिफ्ट श्रेणी के लिए",
        UpdatePdf: "पीडीएफ अपडेट करें",
        PdfCounter: "पीडीएफ काउंटर",
        EnterFolderPath: "फ़ोल्डर पथ दर्ज करें",
        Count: "गिनना",
        EmployeeEntry: "कर्मचारी प्रवेश",
        EmployeeName: "कर्मचारी का नाम",
        Login: "लॉगिन",
        Password: "पासवर्ड",
        Edit: "संपादित करें",
        delete: "मिटाना",
        Export: "निर्यात ",
        Release: "जारी ",
        Post: "पोस्ट ",
        SelectEmployeeName: "कर्मचारी का नाम चुनें",
        ParentName: "जनक नाम",
        EmployeeMaster: "कर्मचारी मास्टर",
        EmpName: "कर्मचारी का नाम",
        EmpCode: "कर्मचारी कोड",
        EmpStatus: "कर्मचारी की स्थिति",
        SelectState: "राज्य का चयन करें",
        SelectCountry: "देश का चयन करें",
        SelectDistrict: "जिले का चयन करें",
        reqEmpName: "कर्मचारी का नाम आवश्यक है",
        reqEmpCode: "कर्मचारी कोड की आवश्यकता है",
        reqFatherName: "पिता का नाम आवश्यक है",
        reqMobNo: "मोबाइल नंबर की आवश्यकता है",
        reqPanNo: "पैन नंबर की आवश्यकता है",
        reqJoiningDate: "ज्वाइनिंग डेट आवश्यक है",
        reqDesignation: "पदनाम की आवश्यकता है",
        reqDepartment: "विभाग की आवश्यकता है",
        reqPerAddress: "स्थायी पते की आवश्यकता है",
        reqPinCode: "पिन कोड की आवश्यकता है",
        reqAdharNo: "आधार नंबर की आवश्यकता है",
        reqEmail: "ईमेल की आवश्यकता है",
        reqEmpdob: "कर्मचारी जन्मतिथि आवश्यक है",
        CreateEmployeeReg: "कर्मचारी पंजीकरण बनाएँ",
        EditEmployeeReg: "कर्मचारी पंजीकरण संपादित करें",
        EnterEmpName: "कर्मचारी का नाम दर्ज करें",
        EnterEmpCode: "कर्मचारी कोड दर्ज करें",
        EnterFatherName: "पिता का नाम दर्ज करें",
        EnterSpauseName: "स्पाज़ नाम दर्ज करें",
        EnterMotherName: "माता का नाम दर्ज करें",
        EnterMobileNumber: "मोबाइल नंबर दर्ज करें",
        EnterEmail: "ईमेल दर्ज करें",
        EnterPanNo: "पैन नंबर दर्ज करें",
        EnterAdharNo: "आधार नंबर दर्ज करें",
        EnterDOB: "जन्म तिथि दर्ज करें",
        EnterJoiningDate: "ज्वाइनिंग डेट दर्ज करें",
        EnterRetirementDate: "सेवानिवृत्ति की तिथि दर्ज करें",
        EnterLocalAddress: "स्थानीय पता दर्ज करें",
        EnterPerAddress: "स्थायी पता दर्ज करें",
        EnterPinCode: "पिन कोड दर्ज करें",
        AttachedImage: "संलग्न छवि",
        DocManagerReport: "दस्तावेज़ प्रबंधक रिपोर्ट",
        SelectSubSubject: " उप विषय का चयन करें",
        SubSubjectName: "उप विषय का नाम",
        DivisionName: "डिवीजन का नाम",
        Remark: "टिप्‍पणी करना",
        SessionYear: "सत्र वर्ष",
        InActive: "निष्क्रिय",
        Active: "सक्रिय",
        TotalDoc: "कुल दस्तावेज़",
        TotalType: "कुल प्रकार",
        TotalIndexFile: "कुल अनुक्रमणिका फ़ाइल",
        TotalSplitFile: "कुल विभाजित फ़ाइल",
        Zone: "क्षेत्र",
        LineChart: "लाइन चार्ट",
        Department: "विभाग",
        AcademicDepartment: "शैक्षणिक विभाग",
        DocumentManagementSystem: "दस्तावेज़ प्रबंधन प्रणाली",
        PartNo: "भाग संख्या",
        PeriodFileNo: "अवधि फ़ाइल संख्या",
        AuthonticatedPerson: "प्रामाणिक व्यक्ति",
        FileDate: "फ़ाइल दिनांक",
        SubjectId: "विषय आईडी ",
        ToDate: "तारिख तक",
        MergeToIndexFile: "इंडेक्स  फ़ाइल में मर्ज करें",
        MergeToOriginalFile: "मूल फ़ाइल में मर्ज करें",
        DOB: "जन्म तिथि",
        Comment: "टिप्पणी",
        enteritemType: "वस्तु प्रकार दर्ज करें",
        ItemMaster: "वस्तु मास्टर",
        enteritemName: "वस्तु नाम दर्ज करें",
        enteritemCode: "वस्तु कोड दर्ज करें",
        enteritemTypeId: "आइटम पहचान दर्ज करें",
        enterempId: "कर्मचारी पहचान दर्ज करें",
        entertaxId: "कर पहचान दर्ज करें",
        itemCategory: "वस्तु श्रेणी",
        enterpurchaseYear: "खरीद वर्ष दर्ज करें",
        unitId: "इकाई नाम",
        enterunitId: "इकाई नाम दर्ज करें",
        entermodelNo: "प्रतिरूप संख्या दर्ज करें",
        enterserialNo: "क्रमानुसार दर्ज करें",
        serialNo: "क्रमानुसार",
        itemType: "वस्तु का प्रकार",
        itemTypecode: "वस्तु प्रकारकोड",
        enteritemTypecode: "एंटर वस्तु प्रकारकोड",
        taxName: "करनाम",
        taxPercentage: "कर प्रतिशत",
        EffectiveDate: "प्रभावी तिथि",
        TaxMaster: "टैक्समास्टर",
        EntertaxName: " करनाम दर्ज करें",
        EntertaxPercentage: "कर प्रतिशत दर्ज करें",
        EntereffectiveDate: "प्रभावी तिथि दर्ज करें",
        itemName: "वस्तु नाम",
        itemCode: "वस्तु कोड",
        purchaseYear: "खरीदवर्ष",
        modelNo: "प्रतिरूप संख्या",
        vehicleNo: "वाहन नं",
        hsnCode: "एचएसएन कोड",
        itemWeight: "वस्तु का वजन",
        entervehicleNo: " वाहन नं दर्ज करें",
        enterchesisNo: " शतरंज नं दर्ज करें",
        chesisNo: "प्रतिरूप संख्या",

        enterhsnCode: " एचएसएन कोड दर्ज करें",
        enteritemWeight: "वस्तु  का वजन दर्ज करें",
        enterdepreciationRate: "मूल्यह्रास दर दर्ज करें",

        enteritemGroupId: "आइटम समूह आईडी दर्ज करें",
        enterwatt: "वाट दर्ज करें",
        entervolt: "वोल्ट दर्ज करें",
        enterwire: "तार दर्ज करें",
        enterweight: "वजन दर्ज करें",
        enteritemColor: "आइटम का रंग दर्ज करें",
        enteritemImg: "आइटम की छवि दर्ज करें",
        enterpowerSource: "बिजली स्रोत दर्ज करें",
        entergenericName: "सामान्य नाम दर्ज करें",
        entermanufacture: "निर्माता दर्ज करें",
        enteritemDimention: "आइटम का माप दर्ज करें",
        enterunderGroundPoleHight: "भूमिगत पोल की ऊँचाई दर्ज करें",
        enternum_Of_Light_Attach: "लगे हुए लाइटों की संख्या दर्ज करें",
        entercurrentStatus: "वर्तमान स्थिति दर्ज करें",
        entercountryOfOrigen: "मूल देश दर्ज करें",

        itemCategoryAbbre: "वस्तुश्रेणीएब्रे",
        parentId: "माता पिता की पहचान",
        taxId: "टैक्स आईडी",
        EnteritemCategory: "वस्तु श्रेणी दर्ज करें",
        EnteritemCategoryAbbre: "वस्तुश्रेणीएब्रे दर्ज करें",
        EntertaxId: "टैक्स आईडी दर्ज करें",
        EntryNo: "प्रविष्टि क्रमांक",
        batchNo: "बैचवाइज",
        itemId: "वस्तुआईडी",
        unitID: "यूनिटआईडी",
        rate: "दर",
        inQty: "मात्रा",
        outQty: "मात्रा से बाहर",
        voucherId: "वाउचरआईडी",
        stockBinId: "स्टॉकबिनआईडी",
        voucherType: "वाउचर प्रकार",
        voucherDate: "वाउचर दिनांक",
        expiryDate: "समाप्ति तिथि",
        companyId: "कंपनी आईडी",
        gstRate: "जीएसटी दर",
        cgst: "सी.जी.एस.टी",
        sgst: "एस.जी.एस.टी",
        igst: "आई.जी.एस.टी",
        gstid: "जी.एस.टी.आईडी",
        cgstid: "सी.जी.एस.टी.आईडी",
        sgstid: "एस.जी.एस.टी आईडी",
        igstid: "आई.जी.एस.टी आईडी",
        StockLedger: "स्टॉकलेजर",
        Purchaseorder: "क्रय आदेश",
        EditPurchaseorder: "क्रय आदेश संपादित करें",
        EnterentryNo: "एंट्री नं दर्ज करें",
        EnterbatchNo: "बैच नं  दर्ज करें",
        EnteritemId: "वस्तु वस्तु दर्ज करें",
        EnterunitID: "यूनिट आईडी दर्ज करें",
        Enterrate: "दर दर्ज करें",
        EnterinQty: "मात्रा दर्ज करें",
        EnteroutQty: "मात्रा से बाहर दर्ज करें",
        EntervoucherId: "वाउचर आईडी  दर्ज करें",
        EntervoucherType: "वाउचर प्रकार दर्ज करें",
        EntervoucherDate: "वाउचर दिनांक  दर्ज करें",
        EnterexpiryDate: "समाप्ति तिथि दर्ज करें",
        EntergstRate: "जीएसटी दर दर्ज करें",
        Entersgst: "एस.जी.एस.टी दर्ज करें",
        Entercgst: "सी.जी.एस.टी दर्ज करें",
        Enterigst: "आई.जी.एस.टी दर्ज करें",
        entergstid: "जी.एस.टी.आईडी दर्ज करें",
        Entersgstid: "एस.जी.एस.टी आईडी दर्ज करें",
        Enterigstid: "आई.जी.एस.टी आईडी  दर्ज करें",
        unitName: "इकाई का नाम",
        unitShortname: "इकाईसंक्षिप्तनाम",
        UnitMaster: "यूनिटमास्टर",
        enterunitName: "इकाई का नाम दर्ज करें",
        enterunitShortname: "इकाईसंक्षिप्तनाम दर्ज करें",
        selectUnit: "इकाई चुनें",
        StoreMaster: "स्टोर मास्टर",
        EnterStoreName: "स्टोरनाम दर्ज करें",
        EnterCapacity: "क्षमता दर्ज करें",
        EnterUnit: "इकाई दर्ज करें",
        EnterSupervisor: "पर्यवेक्षक दर्ज करें",
        EnterStoreKeeper: "दुकानदार दर्ज करें",
        EnterDescription: "विवरण दर्ज करें",
        EnteruploadDate: "अपलोड तिथि दर्ज करें",
        Enterstore_type: "भंडार का प्रकार दर्ज करें",
        storeName: "स्टोर नाम",
        capacity: "क्षमता",
        unit: "इकाई",
        supervisor: "पर्यवेक्षक",
        storeKeeper: "दुकानदार",
        description: "विवरण",
        uploadDate: "अपलोड करने की तारीख",
        store_type: "भंडार प्रकार",
        Selectstore_type: "स्टोर प्रकार चुनें",
        Indoor: "इनडोर",
        Outdoor: "आउटडोर",
        ItemCategory: "आइटम श्रेणी",
        itemCategory: "आइटम श्रेणी",
        itemCategoryAbbre: "आइटम श्रेणी एब्रे",
        parentId: "पेरेंट श्रेणी",
        taxId: "टैक्स आईडी",
        EnteritemCategory: "आइटमश्रेणी दर्ज करें",
        EnteritemCategoryAbbre: " श्रेणी एब्रे दर्ज करें",
        EnterparentId: "पेरेंट आईडी का चयन करें",
        EntertaxId: "टैक्स आईडी दर्ज करें",
        ItemGroup: "आइटम समूह",
        Entergroup_name: "समूह का नाम दर्ज करें",
        Entergroupshortname: "समूह का संक्षिप्त नाम दर्ज करें",
        group_name: "समूह का नाम",
        groupshortname: "समूह का संक्षिप्त नाम ",
        selectGroup: "समूह चुनें",
        itemCategoryAbbre: "वस्तुश्रेणी का संक्षिप्त नाम",
        parentId: "माता पिता की पहचान",
        taxId: "टैक्स आईडी",
        EnteritemCategory: "वस्तु श्रेणी दर्ज करें",
        EnteritemCategoryAbbre: "वस्तुश्रेणी का संक्षिप्त नाम दर्ज करें",
        EntertaxId: "टैक्स आईडी दर्ज करें",
        EntryNo: "प्रविष्टि क्रमांक",
        batchNo: "बैचवाइज",
        itemId: "वस्तुआईडी",
        unitID: "यूनिटआईडी",
        rate: "दर",
        inQty: "मात्रा",
        outQty: "मात्रा से बाहर",
        voucherId: "वाउचरआईडी",
        stockBinId: "स्टॉकबिनआईडी",
        voucherType: "वाउचर प्रकार",
        voucherDate: "वाउचर दिनांक",
        expiryDate: "समाप्ति तिथि",
        companyId: "कंपनी आईडी",
        gstRate: "जीएसटी दर",
        cgst: "सी.जी.एस.टी",
        sgst: "एस.जी.एस.टी",
        igst: "आई.जी.एस.टी",
        gstid: "जी.एस.टी.आईडी",
        cgstid: "सी.जी.एस.टी.आईडी",
        sgstid: "एस.जी.एस.टी आईडी",
        igstid: "आई.जी.एस.टी आईडी",
        StockLedger: "स्टॉकलेजर",
        Purchaseorder: "क्रय आदेश",
        EditPurchaseorder: "क्रय आदेश संपादित करें",
        EnterentryNo: "एंट्री नं दर्ज करें",
        EnterbatchNo: "बैच नं  दर्ज करें",
        EnteritemId: "वस्तु वस्तु दर्ज करें",
        EnterunitID: "यूनिट आईडी दर्ज करें",
        Enterrate: "दर दर्ज करें",
        EnterinQty: "मात्रा दर्ज करें",
        EnteroutQty: "मात्रा से बाहर दर्ज करें",
        EntervoucherId: "वाउचर आईडी  दर्ज करें",
        EntervoucherType: "वाउचर प्रकार दर्ज करें",
        EntervoucherDate: "वाउचर दिनांक  दर्ज करें",
        EnterexpiryDate: "समाप्ति तिथि दर्ज करें",
        EntergstRate: "जीएसटी दर दर्ज करें",
        Entersgst: "एस.जी.एस.टी दर्ज करें",
        Entercgst: "सी.जी.एस.टी दर्ज करें",
        Enterigst: "आई.जी.एस.टी दर्ज करें",
        entergstid: "जी.एस.टी.आईडी दर्ज करें",
        Entersgstid: "एस.जी.एस.टी आईडी दर्ज करें",
        Enterigstid: "आई.जी.एस.टी आईडी  दर्ज करें",
        unitName: "इकाई का नाम",
        unitShortname: "इकाईसंक्षिप्तनाम",
        UnitMaster: "यूनिटमास्टर",
        enterunitName: "इकाई का नाम दर्ज करें",
        enterunitShortname: "इकाईसंक्षिप्तनाम दर्ज करें",

        StoreMaster: "स्टोर मास्टर",
        EnterStoreName: "स्टोरनाम दर्ज करें",
        EnterCapacity: "क्षमता दर्ज करें",
        EnterUnit: "इकाई दर्ज करें",
        EnterSupervisor: "पर्यवेक्षक दर्ज करें",
        EnterStoreKeeper: "दुकानदार दर्ज करें",
        EnterDescription: "विवरण दर्ज करें",
        EnteruploadDate: "अपलोड तिथि दर्ज करें",
        Enterstore_type: "भंडार का प्रकार दर्ज करें",
        storeName: "स्टोर नाम",
        capacity: "क्षमता",
        unit: "इकाई",
        supervisor: "पर्यवेक्षक",
        storeKeeper: "दुकानदार",
        description: "विवरण",
        uploadDate: "अपलोड करने की तारीख",
        store_type: "भंडार प्रकार",
        Selectstore_type: "स्टोर प्रकार चुनें",
        Indoor: "इनडोर",
        Outdoor: "आउटडोर",
        ItemCategory: "आइटम श्रेणी",
        itemCategory: "आइटम श्रेणी",
        itemCategoryAbbre: "आइटम श्रेणी का संक्षिप्त नाम",
        parentId: "पेरेंट श्रेणी",
        taxId: "टैक्स आईडी",
        EnteritemCategory: "आइटमश्रेणी दर्ज करें",
        EnteritemCategoryAbbre: " श्रेणी का संक्षिप्त नाम दर्ज करें",
        EnterparentId: "पेरेंट आईडी का चयन करें",
        EntertaxId: "टैक्स आईडी दर्ज करें",
        ItemGroup: "आइटम समूह",
        Entergroup_name: "समूह का नाम दर्ज करें",
        Entergroupshortname: "समूह का संक्षिप्त नाम दर्ज करें",
        group_name: "समूह का नाम",
        groupshortname: "समूह का संक्षिप्त नाम ",

        JurisdictionMaster: "क्षेत्राधिकार मास्टर",
        EnterJurisdictionName: "क्षेत्राधिकार का नाम दर्ज करें",
        SelectNode: "नोड का चयन करें",
        NodePermission: "नोड अनुमति",
        SelectUser: "उपयोगकर्ता का चयन करें",
        PollMaster: "पोल मास्टर",
        CreatePollMaster: "पोल मास्टर बनाएं",
        poleName: "ध्रुव नाम",
        SelectPollType: "पोल प्रकार चुनें",
        Hight: "ऊंचाई",
        wight: "वज़न",
        Thickness: "मोटाई",
        poleColor: "ध्रुव रंग",
        underGroundPoleHight: "जमीन के नीचे पोल की ऊंचाई",
        numOfLightAttach: "लाइट संलग्न की संख्या",
        currentStatus: "वर्तमान स्थिति",
        poleImg: "ध्रुव छवि",
        EditPollMaster: "पोल मास्टर संपादित करें",
        PoleType: "पोल प्रकार",
        PoleTypeName: "पोल प्रकार का नाम",
        //Inventory Module
        CreateIndent: "इंडेंट बनाएं",
        EditIndent: "इंडेंट संपादित करें",
        estimateNo: "अनुमान संख्या दर्ज करें",
        emp_name: "कर्मचारी का नाम चुनें",
        indentDate: "इंडेंट दिनांक",
        indentNo: "इंडेंट नंबर",
        indent: "इंडेंट फॉर्म",
        ItemName: "आइटम का नाम",
        Unit: "इकाई",
        Quantity: "मात्रा",
        Rate: "दर",
        Amount: "राशि",
        Tax: "कर",
        TaxAmount: "कर राशि",
        DiscountType: "छूट प्रकार",
        Discount: "छूट",
        DiscountAmount: "छूट राशि",
        NetAmount: "नेट अमाउंट",
        document_No: "दस्तावेज़ संख्या दर्ज करें",
        p_InvoiceNo: "खरीद आदेश संख्या दर्ज करें",
        doc_Date: "डॉक्यूमनेट दिनांक चुनें",
        p_InvoiceDate: "खरीदारी चालान दिनांक दर्ज करें",
        supplierName: "आपूर्तिकर्ता का नाम दर्ज करें",
        orderNo: "ऑर्डर नंबर दर्ज करें",
        tax: "कर चुनें",
        freight: "मालभाड़ा दर्ज करें",
        amount: "राशि दर्ज करें",
        acc_code: "Enter Acc_Code",
        others: "अन्य दर्ज करें",
        remark: "टिप्पणी दर्ज करें",
        totalAmount: "कुल राशि",
        supplierNames: "आपूर्तिकर्ता का नाम",
        document_Nos: "दस्तावेज़ संख्या",
        p_InvoiceNos: "खरीद आदेश संख्या",
        doc_Dates: "डॉक्यूमनेट दिनांक",
        orderNos: "ऑर्डर नंबर",
        p_InvoiceDates: "खरीदारी चालान दिनांक",
        freights: "मालभाड़ा",
        amounts: "राशि",
        qc: "गुणवत्ता जांच",
        qcDate: "गुणवत्ता दिनांक",
        mrnType: "एमआरएन प्रकार",
        totalAmounts: "कुल राशि",
        createQualityCheck: "गुणवत्ता जांच बनाएं",
        qcNo: "एंटर गुणवत्ता जांच नं",
        qcDate: "एंटर गुणवत्ता जांच दिनांक",
        selectMRN: "एमआरएन चुनें",
        bill_ChalanNo: "बिल/चालान नं",
        bill_ChalanDate: "बिल/चालान दिनांक",
        shipmentNo: "शिपमेंट नं",
        VendorDetails: "वेंडर विवरण",
        SelectVendor: "वेंडर चुनें",
        vendorGstin: "वेंडर GSTIN",
        vendorContactPerson: "वेंडर संपर्क व्यक्ति",
        vendorAddress: "वेंडर आवास",
        vendorMobileNo: "वेंडर मोबाइल नं",
        OrderNo: "ऑर्डर नं",
        Item: "आइटम",
        BatchNo: "बैच नं",
        BalQty: "बैल क्यूटी",
        ApproveQty: "अप्रोव क्यूटी",
        ApproveQty1: "अप्रोव क्यूटी",
        Rate: "दर",
        Amount: "राशि",
        GSTRate: "जीएसटी दर",
        CGST: "CGST",
        SGST: "SGST",
        IGST: "IGST",
        NetAmount: "नेट राशि",
        totalCGST: "कुल CGST",
        totalSGST: "कुल SGST",
        totalIGST: "कुल IGST",
        Remark: "टिप्पणी दर्ज करें",
        totalGrossAmount: "कुल ग्रोस राशि",
        totalGrossAmounts: "कुल ग्रोस राशि",
        totalGrossAmountReadOnly:
          "कुल ग्रोस राशि केवल पढ़ने के लिए है, इसे संपादित नहीं किया जा सकता",
        totalIGSTReadOnly:
          "कुल IGST केवल पढ़ने के लिए है, इसे संपादित नहीं किया जा सकता",
        totalCGSTReadOnly:
          "कुल CGST केवल पढ़ने के लिए है, इसे संपादित नहीं किया जा सकता",
        totalSGSTReadOnly:
          "कुल SGST केवल पढ़ने के लिए है, इसे संपादित नहीं किया जा सकता",
        totalAmountReadOnly:
          "कुल राशि केवल पढ़ने के लिए है, इसे संपादित नहीं किया जा सकता",
        mrnNo: "एमआरएन नंबर दर्ज करें",
        // EditMaterialRecieptNote:"Edit Material RecieptNote",
        mrnDate: "एंटर एमआरएन दिनांक",
        createMaterialRecieptNote: "आइटम प्राप्ति नोट बनाएं",
        EditMaterialRecieptNote: "आइटम प्राप्ति नोट संपादित करें",
        mrn: "आइटम प्राप्ति नोट",
        SupplierName: "आपूर्तिकर्ता का नाम",
        Vendordetails: "विक्रेता विवरण",
        Unit: "इकाई",
        AcceptQty: "अप्रोव क्यूटी",
        MrnQty: "एमआरएन क्यूटी",
        RejectQty: "रिजेक्ट क्यूटी",
        Reason: "विवरण",
        createVendor: "वेंडर बनाएं",
        editVendor: "वेंडर संपादित करें",
        vendorName: "वेंडर नाम दर्ज करें",
        vendorCode: "वेंडर कोड दर्ज करें",
        tanno: "टानो दर्ज करें",
        SelectCity: "शहर चुनें",
        gstin: "जीएसटीआईएन दर्ज करें",
        adharNumber: "आधार नंबर दर्ज करें",
        contactPerson: "संपर्क व्यक्ति दर्ज करें",
        permanentAddress: "अच्छाई आवास",
        pincode: "पिनकोड दर्ज करें",
        AttachedSignature: "अपलोड हस्ताक्षर",
        AttachedPan: "अपलोड पैन कार्ड",
        AttachedGSTIN: "अपलोड जीएसटीआईएन",
        AttachedTan: "अपलोड टान",
        AttachedAadhar: "अपलोड आधार",
        vendorMaster: "वेंडर मास्टर",
        editVendorMaster: "वेंडर मास्टर संपादित करें",
        contactPersons: "संपर्क व्यक्ति",
        totalTax: "कुल कर",
        Tax: "कर",
        TaxAmount: "कर राशि",
        DiscountType: "छूट प्रकार",
        Discount: "छूट",
        DiscountAmount: "छूट राशि",
        NetAmount: "नेट अमाउंट",
        document_No: "दस्तावेज़ संख्या दर्ज करें",
        p_InvoiceNo: "खरीद आदेश संख्या दर्ज करें",
        doc_Date: "डॉक्यूमनेट दिनांक चुनें",
        p_InvoiceDate: "खरीदारी चालान दिनांक दर्ज करें",
        supplierName: "आपूर्तिकर्ता का नाम दर्ज करें",
        orderNo: "ऑर्डर नंबर दर्ज करें",
        tax: "कर चुनें",
        freight: "मालभाड़ा दर्ज करें",
        amount: "राशि दर्ज करें",
        acc_code: "Enter Acc_Code",
        others: "अन्य दर्ज करें",
        remark: "टिप्पणी दर्ज करें",
        totalAmount: "कुल राशि",
        supplierNames: "आपूर्तिकर्ता का नाम",
        document_Nos: "दस्तावेज़ संख्या",
        p_InvoiceNos: "खरीद आदेश संख्या",
        doc_Dates: "डॉक्यूमनेट दिनांक",
        orderNos: "ऑर्डर नंबर",
        p_InvoiceDates: "खरीदारी चालान दिनांक",
        freights: "मालभाड़ा",
        amounts: "राशि",
        VendorMaster: "विक्रेता मास्टर",
        entername: "नाम दर्ज करें",
        entercode: "कोड दर्ज करें",
        enterpermanentAddress: "स्थायी पता दर्ज करें",
        entercontactPerson: "संपर्क व्यक्ति दर्ज करें",
        entermobileNo: "मोबाइल नंबर दर्ज करें",
        enterpanNumber: "पैन नंबर दर्ज करें",
        enteraddharNo: "आधार नंबर दर्ज करें",
        entergstinNo: "जीएसटीएन नंबर दर्ज करें",
        enterstateId: "राज्य आईडी दर्ज करें",
        entercountryId: "देश आईडी दर्ज करें",
        entercityId: "शहर की आईडी दर्ज करें",
        enterpincode: "पिनकोड दर्ज करें",
        CreateIndentApproval: "क्रिएट इंडेंट अप्रूवल",
        selectIndentNo: "इंडेंटनंबर चुनें",
        indentDate: "इंडेंट तारीख",
        reqBefDate: "तिथि से पहले अनुरोध करें",
        EnterEmpName: "कर्मचारी का नाम दर्ज करें",
        emp_name: "कर्मचारी का नाम",
        storeID: "स्टोर आईडी",
        ApproveAllItems: "सभी वस्तुओं को सभी मात्रा में स्वीकृत करें",
        ShowExisting: "मौजूदा दिखाएँ",
        CreateForwardLevel: "आगे का स्तर बनाएं",
        Action: "कार्रवाई",
        Forward: "आगे का स्तर",
        Refuse: "अस्वीकार करना",
        CreateIndentStore: "इंडेंट स्टोर बनाएं",
        Pass: "उत्तीर्ण",
        JobWork: "ठेके का काम",
        jobCardNo: "जॉब कार्ड नं",
        jobCardDate: "जॉबकार्ड दिनांक",
        complain: "शिकायत करना",
        CreateComplaint: "शिकायत बनाएँ",
        complaintDate: "शिकायत दिनांक",
        complaintNo: "शिकायत क्रमांक",
        itemID: "आइटम का नाम चुनें",
        complaintType: "शिकायत का प्रकार",
        complaintDoc: "complaintDoc",
        empId: "कर्मचारी का नाम चुनें",
        complaint: "शिकायत",
        AutoIndentForm: "ऑटो इंडेंट फॉर्म",
        reqBefDate: "दिनांक से पहले अनुरोध का चयन करें",
        storeId: "स्टोर चुनें ",
        patCodeNo: "पैटकोड नंबर दर्ज करें",
        Service: "सेवा",
        Vendor: "विक्रेता",
        Qty: "मात्रा",
        UnitRate: "यूनिट दर",
        Reading: "रीडिंग",
        ChallanNo: "चालान संख्या",
        createitemMaster: "आइटम मास्टर बनाएं",
        edititemMaset: "आइटम मास्टर संपादित करें",
        selectitemTypeId: "आइटम प्रकार चुनें",
        selectItemCategory: "आइटम श्रेणी चुनें",
        itemNameRequired: "आइटम का नाम आवश्यक है",
        itemNameMin: "आइटम का नाम कम से कम 2 अक्षर का होना चाहिए",
        itemNameMax: "आइटम का नाम 200 अक्षरों से अधिक नहीं हो सकता",
        inqty: "मात्रा दर्ज करें",
        totalAmountafterTax: "कुल राशि कर के बाद",
        editStockledger: "स्टॉक लीडर संपादित करें",
        selectJobCard: "जॉब कार्ड चुनें",
        selectItem: "आइटम चुनें",
        approveEmp1: "स्वीकृत कर्मचारी चुनें 1",
        approveEmp2: "स्वीकृत कर्मचारी चुनें 2",
        approveEmp3: "स्वीकृत कर्मचारी चुनें 3",
        approveEmp4: "स्वीकृत कर्मचारी चुनें 4",
        reqitem: "आइटम का चयन आवश्यक है",
        reqEmp: "कर्मचारी का चयन आवश्यक है",
        reqComNo: "शिकायत संख्या आवश्यक है",
        StaffIndent: "स्टाफ इंडेंट",
        createStaffIndent: "स्टाफ़ इंडेंट बनाएं",
        EditStaffIndent: "स्टाफ़ इंडेंट संपादित करें",
        StaffItemReturn: "स्टाफ आइटम रिटर्न",
        createStaffItemReturn: "स्टाफ आइटम रिटर्न बनाएं",
        EditStaffItemReturn: "स्टाफ आइटम रिटर्न संपादित करें",
        StaffItemIssue: "स्टाफ मद मुद्दा",
        createStaffItemIssue: "स्टाफ आइटम मुद्दा बनाएं",
        EditStaffItemIssue: "स्टाफ़ आइटम समस्या संपादित करें",
        AprQty: "स्वीकृत मात्रा",
        IndentNo: "इंडेंट नंबर",
        Date: "तारीख",
        IssueDate: "जारी करने की तारीख",
        Required: "आवश्यक",
        Stock: "भंडार",
        Issue: "मुद्दा",
        Employee: "कर्मचारी",
        IndentDates: "इंडेंट दिनांक",
        ReturnDate: "वापसी दिनांक",
        Scrabble: "खरोंचना",
        Indent: "मांगपत्र",
        PendingQty: "लंबित मात्रा",
        ReturnQty: "वापसी मात्रा",
        ComplaintTypeMaster: "शिकायत प्रकार मास्टर",
        compTypeName: "शिकायत प्रकार का नाम",
        apprImg: "अनुमोदन छवि",
        ComplainDate: "शिकायत तिथि",
        EnterComplain: "शिकायत दर्ज करें",
        Complain: "शिकायत",
        AssignComplain: "शिकायत असाइन करें",
        InventoryToAsset: "संपत्ति के लिए सूची",
        Quantity: "मात्रा",
        StoreName: "स्टोर नाम",
        AreaWard: "क्षेत्र/वार्ड",
        EnterZone: "जोन चुनें",
        EnterWardNumber: "वार्ड संख्या दर्ज करें",
        EnterAreaName: "क्षेत्र का नाम दर्ज करें",
        AreaName: "क्षेत्र का नाम",
        WardNumber: "वार्ड क्रमांक",
        RouteDetail: "मार्ग विवरण",
        EnterRouteName: "मार्ग का नाम दर्ज करें",
        EnterRouteDate: "मार्ग दिनांक दर्ज करें",
        EnterRouteDesc: "मार्ग विवरण दर्ज करें",
        RouteName: "मार्ग का नाम",
        RouteDesc: "विवरण",
        RouteDate: "मार्ग दिनांक",
        RosterVisit: "रोस्टर विजिट",
        VisitNumber: "विज़िट संख्या",
        SelectRoster: "रोस्टर समूह चुनें",
        ItemNumber: "वस्तु संख्या",
        WarrantyDate: "गारंटी दिनांक",
        Ward: "वार्ड",
        Roster: "रोस्टर",
        Warranty: "गारंटी",
        VisitDate: "विज़िट दिनांक",
        WardNo: "वार्ड संख्या",
        reqEmpName: "कर्मचारी का नाम आवश्यक है",
        reqEstimateNum: "अनुमान संख्या आवश्यक है",
        reqDocumentNum: "दस्तावेज़ संख्या आवश्यक है",
        reqOrderNum: "ऑर्डर संख्या आवश्यक है",
        reqOrderDate: "ऑर्डर दिनांक आवश्यक है",
        reqInvDate: "चालान दिनांक आवश्यक है",
        reqSuppName: "आपूर्तिकर्ता का नाम आवश्यक है",
        Purchaseorderdetails: "खरीद ऑर्डर विवरण",
        reqPollNum: "पोल संख्या आवश्यक है",
        reqItemName: "आइटम का नाम आवश्यक है",
        reqQcDate: "QC तिथि आवश्यक है",
        reqBillNum: "बिल/चालान संख्या आवश्यक है",
        reqBillDate: "बिल/चालान दिनांक आवश्यक है",
        Approve: "मंज़ूरी देना",
        reqIndentNum: "इंडेंट नंबर आवश्यक है",
        SelectIndentNo: "इंडेंट नंबर चुनें",
        SelectindentDate: "इंडेंट दिनांक चुनें",
        SelectreqBefDate: "सत्यापन तिथि चुनें",
        CreateIndentForwardLevel: "इंडेंट फॉरवर्ड लेवल बनाएं",
        reqZoneName: "ज़ोन का नाम आवश्यक है",
        reqdeptName: "विभाग का नाम आवश्यक है",
        reqAreaname: "क्षेत्र का नाम आवश्यक है",
        reqWardNum: "वार्ड संख्या आवश्यक है",
        reqItemType: "आइटम प्रकार आवश्यक है",
        reqTaxName: "कर नाम आवश्यक है",
        reqTaxPercent: "कर प्रतिशत आवश्यक है",
        reqUnitName: "इकाई का नाम आवश्यक है",
        reqStoreName: "स्टोर का नाम आवश्यक है",
        EmpNameRequired: "कर्मचारी का नाम आवश्यक है",
        EmpCodeRequired: "कर्मचारी कोड आवश्यक है",
        MobNoRequired: "मोबाइल नंबर आवश्यक है",
        PanNoRequired: "पैन नंबर आवश्यक है",
        AdharNoRequired: "आधार नंबर आवश्यक है",
        reqBatchnum: "बैच नंबर आवश्यक है",
        CreateStockledger: "स्टॉक लेजर बनाएं",
        SelectitemId: "आइटम का नाम चुनें",
        reqQuantity: "मात्रा आवश्यक है",
        reqItemCategory: "आइटम श्रेणी आवश्यक है",
        reqGroupName: "समूह का नाम आवश्यक है",
        reqPollName: "पोल नाम आवश्यक है",
        reqPollType: "पोल प्रकार आवश्यक है",
        reqcompTypeName: "शिकायत प्रकार आवश्यक है",
        reqAssignDate: "शिकायत तिथि आवश्यक है",
        reqComplain: "शिकायत जरूरी है",
        reqRouteName: "मार्ग का नाम आवश्यक है",
        reqRouteDate: "मार्ग दिनांक आवश्यक है",
        reqVisitNum: "विज़िट संख्या आवश्यक है",
        reqVisitDate: "यात्रा की तारीख आवश्यक है",
        reqItemStatus: "आइटम स्थिति आवश्यक है",
        reqWarranty: "वारंटी आवश्यक है",
        reqRosterGroup: "रोस्टर समूह आवश्यक है",
        reqItemNum: "आइटम नंबर आवश्यक है",
        FatherNameRequired: "पिता का नाम आवश्यक है",
        DobRequired: "जन्मतिथि आवश्यक है",
        JoiningDateRequired: "ज्वाइनिंग तिथि आवश्यक है",
        DesignationRequired: "पदनाम आवश्यक है",
        PermanentAddressRequired: "स्थायी पता आवश्यक है",
        PincodeRequired: "पिनकोड आवश्यक है",
        jwchallan: "जॉब वर्क चालान",
        reqCountryName: "देश का नाम आवश्यक है",
        reqStoreId: "स्टोर आवश्यक चुनें",
        OpeningStockOfItems: "वस्तुओं का प्रारंभिक स्टॉक",
        enterunit: "इकाई का चयन करें",
        enteritem: "आइटम का चयन करें",
        vouchertype: "वाउचर प्रकार",
        item: "वस्तु",
        SelectSupplierName: "आपूर्तिकर्ता का नाम चुनें",
        SelectIndent: "इंडेंट का चयन करें",
        PurchaseNo: "खरीद संख्या",
        PurchaseInvoice: "खरीद चालान",
        editPurchaseorder: "खरीद चालान संपादित करें",
        PurchaseReturn: "खरीद वापसी",
        PurchaseInvoiceOption: "क्रय चालान चुनें",
        pR_InvoiceDate: "खरीद वापसी चालान तिथि",
        pR_InvoiceNo: "खरीद वापसी चालान संख्या",
        PurchaseReturnorder: "खरीद वापसी आदेश",
        EditPurchaseReturnorder: "खरीद वापसी आदेश संपादित करें",
        CreateMrnDetails: "एमआरएन विवरण बनाएं",
        EditMrnDetails: "एमआरएन विवरण संपादित करें",
        MrnDetails: "एमआरएन विवरण",
        MrnNo: "एमआरएन संख्या",
        SelectOrderNO: "ऑर्डर नंबर चुनें",
        GstNoRequired: "जीएसटीआईएन की आवश्यकता है",
        StockReport: "स्टॉक रिपोर्ट",
        SelectItem: "आइटम का चयन करें",
        StockSummary: "स्टॉक सारांश",
        ComplainApprovalMaster: "शिकायत अनुमोदन मास्टर",
        ComplaintApproval: "शिकायत अनुमोदन ",
        InQuantity: "मात्रा में",
        UnitName: "इकाई का नाम",
        SelectStore: "स्टोर चुनें",
        ReturnQuantity: "वापसी मात्रा",
        SelectPurchaseOrder: "क्रय आदेश चुनें",
        EditComplaint: "शिकायत संपादित करें",
        Map: "मानचित्र",
        CreatePurchaseOrder: "क्रय आदेश बनाएं",
        AutoPurchaseOrder: "ऑटो खरीद आदेश",
        PurchaseOrderDate: "क्रय आदेश दिनांक",
        EditPurchaseOrder: "खरीद आदेश संपादित करें",
        ApprovedDate: "स्वीकृत तिथि",
        InstallationDate: "स्थापना तिथि",
        ComplaintDate: "शिकायत दिनांक",
        ComplaintNo: "शिकायत क्रमांक",
        Complaint: "शिकायत",
        ComplaintType: "शिकायत का प्रकार",
        ComplainAssignTo: "शिकायत असाइन करें",
        SelectPole: "ध्रुव का चयन करें",
        Institute: "संस्थान ",
        ResidencialAddress: "निवास का पता",
        CollegeCategory: "कॉलेज श्रेणी",
        InstituteName: "संस्थान का नाम",
        LetterNo: "पत्र संख्या",
        Priority: "प्राथमिकता",
        Language: "भाषा",
        CreateInstitute: "संस्थान बनाएँ",
        EditInstitute: "संस्थान संपादित करें",
        ShowAcademicSession: "शैक्षणिक सत्र दिखाएं",
        ShowFinancialYear: "वित्तीय वर्ष दिखाएं",
        EditAcademicSession: "शैक्षणिक सत्र संपादित करें",
        EditableFinancialYear: "संपादन योग्य वित्तीय वर्ष",
        DefaultJurisdiction: "डिफ़ॉल्ट क्षेत्राधिकार",
        OrgType: "संगठन प्रकार :",
        Yes: "हाँ",
        No: "नहीं",
        School: "पाठशाला",
        College: "महाविद्यालय",
        University: "विश्‍वविद्यालय",
        Address: "पता",
        District: "जिला",
        YearOfEstablishment: "स्थापना का वर्ष",
        Category: "श्रेणी ",
        Principal: "प्रिंसिपल",
        collegeStatus: "कॉलेज की स्थिति",
        ResidencialAddress: "निवास का पता",
        MobNo: "मोबाइल नंबर",
        OficeNO: "ऑफिस नंबर",
        ResiNO: "रेसी संख्या",
        PinCode: "पिन कोड",
        Fax: "फ़ैक्स",
        Website: "वेबसाइट",
        DistrictArea: "जिला क्षेत्र",
        StatusPg: "स्थिति पीजी",
        Registrar: "कुल सचिव",
        NameOfFaculties: "संकायों का नाम",
        NoOfTeachers: "शिक्षकों की संख्या",
        DateFrom: "तिथि से",
        AccesedByNaac: "एन.ए.ए.सी  द्वारा स्वीकार किया गया",
        SessionYear: "सत्र वर्ष",
        ReAtendenceDuration: "पुनः अटेंडेंस अवधि",
        EnableAutoStuCredentials: "ऑटो छात्र क्रेडेंशियल सक्षम करें",
        SelectStudentRoles: "छात्र भूमिकाओं का चयन करें",
        EnableAutoEmpCredentials: "ऑटो कर्मचारी क्रेडेंशियल्स सक्षम करें",
        SelectEmployeeRoles: "कर्मचारी भूमिकाएँ चुनें",
        EnableBiometric: "बायोमेट्रिक सक्षम करें",
        EnableDualBiometric: "दोहरी बायोमेट्रिक सक्षम करें",
        MenuType: "मेनू प्रकार",
        SelectParentInstitute: "पैरेंट इंस्टीट्यूट का चयन करें",
        MenuOverColor: "मेनू ओवर कलर",
        MenuBackColor: "मेनू बैक  रंग",
        Attachedlogo: "संलग्न लोगो",
        UploadImage: "छवि अपलोड करें",
        ReportHeaderImg: "रिपोर्ट हेडर इमेज",
        ReportFooterImg: "रिपोर्ट पाद लेख छवि",
        ReportHeader: "रिपोर्ट हैडर",
        EnterNoOnly: "केवल नंबर दर्ज करें",
        reqYearOfEstablishment: "स्थापना वर्ष की आवश्यकता है",
        reqMobNo: "मोबाइल नंबर की आवश्यकता है",
        reqMinTenDigits: "न्यूनतम 10 अंकों की आवश्यकता है",
        reqNoOfTeachers: "शिक्षकों की संख्या आवश्यक है",
        reqSessionYear: "सत्र वर्ष की आवश्यकता है",
        reqReAtendenceDuration: "पुनः उपस्थिति अवधि की आवश्यकता है",
        SelectDevision: "डिवीजन का चयन करें",
        SelectRoot: "रूट का चयन करें",
        AddEmailSetting: "ईमेल सेटिंग जोड़ें",
        EditEmailSetting: "ईमेल सेटिंग संपादित करें",
        Host: "समुदाय",
        Port: "पत्तन",
        SelectWarranty: "वारंटी चुनें",
        SelectHSN: "एचएसएन चुनें",
        HsnMaster: "एचएसएन मास्टर",
        hsnName: "एचएसएन नाम",
        warrantyName: "वारंटी का नाम",
        WarrantyMaster: "वारंटी मास्टर",
        StatusMaster: "स्टेटस मास्टर",
        ComplainStatus: "शिकायत की स्थिति",
        Escrap: "ई स्क्रैप",
        EscrapDate: "ई स्क्रैप तिथि",
        ExpiryDate: "समाप्ति तिथि",
        ComplaintDescription: "शिकायत विवरण",
        OutQuantity: "बाहर की मात्रा",
        ComplaintStatus: "शिकायत की स्थिति",
        SelectEmployee: "कर्मचारी का चयन करें",
        SelectComplaintNo: "शिकायत संख्या चुनें",
        PoleInstalledReport: "पोल स्थापित रिपोर्ट",
        MrnDetailsReport: "एम.आर.एन विवरण रिपोर्ट",
        SelectMRN: "एमआरएन चुनें",
        QualityCheckReport: "गुणवत्ता जांच रिपोर्ट",
        SelectQc: "क्यूसी का चयन करें",
        PurchaseBillReport: "खरीद बिल रिपोर्ट",
        DeviceSchedule: "डिवाइस शेड्यूल",
        OnTime: "समय पर",
        OffTime: "समय बंद",
        ComplaintDesc: "शिकायत विवरण",
        OpenHight: "ऊपर की ऊंचाई",
        SelectDeviceNo: "डिवाइस नंबर चुनें",
        PageSetup: "पृष्ठ सेटअप",
        PageName: "पेज का नाम",
        FieldName: "फ़ील्ड का नाम",
        IsActive: "सक्रिय है",
        SelectComplainNo: "शिकायत संख्या चुनें",
        Source: "स्रोत",
        TypeOfPole: "पोल का प्रकार",
        Weight:"वज़न",
        TypeOfLight:"प्रकाश का प्रकार"
      },
      content: {},
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: storedLanguage || "en",
  // lng: 'hi',
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
